<!-- =========================================================================================
  File Name: UserEdit.vue
  Description: User Edit Page
  ---------------------------------------------------------------------
  -------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-edit">
   <!-- {{ structure_components }} -->
  
    <vx-card >
   

      <div slot="no-body" class="tabs-container px-6 pt-6">

        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Conta" icon-pack="feather" icon="icon-user">
            <div class="tab-text">
              <div id="user-edit-tab-info">

    <!-- Avatar Row -->
    <div class="vx-row mb-5">
      <div class="vx-col w-full">
        <div class="flex items-start flex-col sm:flex-row">
          <img v-if="employee.user.image" class="mr-8 rounded h-24 w-24" :src="employee.user.image" size="80px"  />
          <i v-else class="fad fa-user-circle fa-5x ml-2 mr-8 text-primary"></i>
          <div>
            <p class="text-lg font-medium mb-2 mt-4 sm:mt-0"></p>
            <vs-input type="file" class="hidden" ref="update_avatar_input"  v-model="ficheiro1" name="imagem"  @change="previewImage" accept="image/*">
            </vs-input>
            <!-- Toggle comment of below buttons as one for actual flow & currently shown is only for demo -->
            <vs-button :disabled="!canUpdateEmp" class="mr-4 mb-4"  @click="$refs.update_avatar_input.click()">Carregar foto</vs-button>
            <!-- <vs-button type="border" class="mr-4" @click="$refs.update_avatar_input.click()">Change Avatar</vs-button> -->

            <vs-button  v-if="imagem!==''" type="border" size="small" color="primary" @click="saveProfilePicture">
              
              <i class="fas fa-sync fa-2x"></i>
            
              
              </vs-button>
            <p v-if="process==false" class="text-sm mt-2">Formatos suportados JPG, JPEG or PNG.</p>
           <p v-if="process==true"> <vs-progress indeterminate color="primary"></vs-progress></p>
          </div>
        </div>
      </div>
    </div>
 <div class="vx-row">
    <!-- VERTICAL LAYOUT WITH ICON-->
    <div class="vx-col w-full mb-base">
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
             <label class="text-sm font-bold">Nome</label>
            <div class="vx-col w-full">
              <vs-input
                class="w-full"
                icon-pack="feather"
                icon="icon-user"
                icon-no-border
                v-model="employee.user.name"
              />
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label class="text-sm font-bold">Apelido</label>
            <div class="vx-col w-full">
              <vs-input
                class="w-full"
                icon-pack="feather"
                icon="icon-user"
                icon-no-border
                v-model="employee.user.surname"
              />
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
           <label class="text-sm font-bold">Telefone</label>
            <div class="vx-col w-full">
              <vs-input
                class="w-full"
                icon-pack="feather"
                icon="icon-smartphone"
                icon-no-border
                v-model="employee.contacts.phone"
                type="number"
              />
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
          <label class="text-sm font-bold">Email</label>
            <div class="vx-col w-full">
              <vs-input
                type="email"
                class="w-full"
                icon-pack="feather"
                icon="icon-mail"
                icon-no-border
                v-model="employee.user.email"
              />
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div class="vx-col w-full">
               <label class="text-sm font-bold">Data de Nascimento</label>
              <vs-input
                class="w-full"
                icon-pack="feather"
                icon-no-border
                v-model="employee.birth_date"
                type="date"
              />
         
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            
            <div class="vx-col w-full">
      <label class="text-sm font-bold">Gênero</label>
      <div class="mt-2">
        <vs-radio v-model="employee.gender" vs-value="Masculino" class="mr-4">Masculino</vs-radio>
        <vs-radio v-model="employee.gender" vs-value="Feminino" class="mr-4">Feminino</vs-radio>
      </div>
    </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div class="vx-col w-full">
              
               <label class="text-sm font-bold">Estado Civil</label>
           
              <select  class="block w-full pl-3 pr-10 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed" v-validate="'excluded:1,2,3'"  v-model="employee.marital_status" name="not_in_field" data-vv-as="selected">
    <option  value="1">Solteiro(a)</option>
    <option class="vs__selected-options" value="2">Casado(a)</option>
    <option class="vs__selected-options" value="3">Divorciado(a)</option>
    <option class="vs__selected-options" value="4">Viúvo(a)</option>
  </select>
             
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
           <label class="text-sm font-bold">Endereço</label> 
            <div class="vx-col w-full">
              <vs-input
                class="w-full"
                icon-pack="feather"
                icon="icon-map-pin"
                icon-no-border
                v-model="employee.address"
              />
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div class="vx-col w-full">
              <!-- Nacionalidade

              <ul class="centerx">
                <li>
                  <vs-radio v-model="type" vs-value="BI">Mocambicana</vs-radio>
                </li>
                <li>
                  <vs-radio v-model="type" vs-value="DIRE"
                    >Estrangeira</vs-radio
                  >
                </li>
              </ul> -->

               <div class="vx-col w-full">
      <label class="text-sm font-bold">Nacionalidade</label>
      <div class="mt-2">
        <vs-radio v-model="employee.document_type" vs-value="BI" class="mr-4">Mocambicana</vs-radio>
        <vs-radio v-model="employee.document_type" vs-value="DIRE"  class="mr-4">Estrangeira</vs-radio>
      </div>
    </div>
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div class="vx-col w-full">
              <div class="vx-col w-full"> 
                <label class="text-sm font-bold">Pais</label>
                <v-select
                  v-bind:disabled="employee.document_type == 'BI'"
                  :options="options"
                  v-model="employee.nationality"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div class="vx-col w-full" v-if="employee.document_type == 'BI'">
                 <label class="text-sm font-bold">Tipo de documento</label> <br />
              <span >Bilhete de Identidade</span>
             
            </div>
            <div class="vx-col w-full" v-else>
               <v-select  v-model="employee.document_type" :options="['DIRE','PASSAPORTE']"> </v-select>
              
            </div>
          </div>

          
          
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div class="vx-col w-full">
               <label class="text-sm font-bold">Número do documento</label>
              <vs-input
                class="w-full"
                icon-pack="feather"
                icon="icon-hash"
                icon-no-border
                v-model="employee.document_number"
              />
            </div>
          </div>
         
        </div>

        

 <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
          <label class="text-sm font-bold">NUIT</label>
            <div class="vx-col w-full">
              <vs-input
                class="w-full"
                icon-pack="feather"
                icon-no-border
                v-model="employee.nuit"
                type="number"
              />
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div class="vx-col w-full">
               <label class="text-sm font-bold">INSS</label>
              <vs-input
                class="w-full"
                icon-pack="feather"
                icon-no-border
                v-model="employee.inss"
                type="number"
              />
            </div>
          </div>
          <!-- <div class="vx-col sm:w-1/2 w-full mb-2">
            <div class="vx-col w-full">
               <label class="text-sm font-bold">Numero de Dependentes</label>
              <vs-input
                class="w-full"
                icon-pack="feather"
                icon-no-border
                v-model="employee.dependent"
                type="number"
              />
            </div>
          </div> -->
        </div>

         <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div class="vx-col w-full">
               <label class="text-sm font-bold">Departamento</label>
               <v-select
                 label="name"
                  :options="departments"
                  v-model="selectedDepartment"
                />
      
                
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div class="vx-col w-full">
              
                <label class="text-sm font-bold">Função</label>
     <v-select
                 label="name"
                  :options="company_roles"
                  v-model="selectedPosition"
                />

      
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div class="vx-col w-full">
               <label class="text-sm font-bold">Salário Base</label>
              <vx-input-group class="mb-base">
                <vs-input type="number" v-model="employee.basic_salary" />

                <template slot="append">
                  <div class="append-text bg-primary">
                    <span>.MT</span>
                  </div>
                </template>
              </vx-input-group>
            </div>
          </div>
         
        </div>


         
        
     
        <p > <vs-progress v-if="process==true" indeterminate color="primary"></vs-progress></p>

        <!-- CODE -->
    </div>
  </div>
  </div>
            </div>
          </vs-tab>
          <vs-tab label="Subsídios" icon-pack="feather" icon="icon-dollar-sign">
           <div class="tab-text">
         <vs-table search stripe :data="structure_components">
     
<template  slot="header">
         
          </template>
  <template slot="thead">
    <vs-th sort-key="name">Nome</vs-th>
    <vs-th sort-key="name">Abreviatura</vs-th>
    <vs-th sort-key="name">Valor</vs-th>
    <vs-th></vs-th>
    

    <!-- <vs-th sort-key="birth_date">Data de Nascimento</vs-th> -->
    <!-- <vs-th sort-key="id">Nro</vs-th> -->
  </template>

  <template slot-scope="{data}">
    <!-- <vs-tr  :key="indextr" v-for="(tr, indextr) in data">
      
      <vs-td :data="data[indextr].name">
       
        {{ data[indextr].name }}
      </vs-td>
      <vs-td :data="data[indextr].abbreviation">
       
        {{ data[indextr].abbreviation }}
      </vs-td>
       
    
    
      <vs-td :data="data[indextr].pivot.amount">
        <span v-if="data[indextr].abbreviation=='IRPS' || data[indextr].abbreviation=='INSS'">Cálculo automático </span>
       <span v-else>  {{ data[indextr].pivot.amount }}</span>
       
     </vs-td>
   

    
      <vs-td  :data="data[indextr].id">
        <vs-row>
                    <vs-button :disabled="data[indextr].abbreviation=='INSS' || data[indextr].abbreviation=='IRPS' " color="success" size="small" hover:text-danger type="border" icon-pack="feather" icon="icon-edit"  @click="popupOpenEditComponent(tr)">

                    </vs-button>
                    <vs-button class="ml-2" color="danger"  type="border" size="small" icon-pack="feather" icon="icon-trash" @click="openComponentConfirm(tr)"></vs-button>
             </vs-row>
            
            </vs-td>

    </vs-tr> -->


    <vs-tr v-for="data in structure_components" :key="document.id">
                  <template v-if="data.abbreviation!='INSS' && data.abbreviation!='IRPS'">
                <vs-td>{{data.name}}</vs-td>
              <vs-td>{{data.abbreviation}}</vs-td>
              
               <vs-td>
                {{ data.pivot.amount }}
              </vs-td>
              
                <vs-td class="whitespace-no-wrap">
       <vs-row>
        <vs-button :disabled="data.abbreviation=='INSS' || data.abbreviation=='IRPS' " color="success" size="small" hover:text-danger type="border" icon-pack="feather" icon="icon-edit"  @click="popupOpenEditSubsidio(data)">

        </vs-button>
        <vs-button class="ml-2" color="danger"  type="border" size="small" icon-pack="feather" icon="icon-trash" @click="openComponentConfirm(data)"></vs-button>
           
             </vs-row>
            </vs-td>
                  </template>
              
              
              </vs-tr> 
  </template>
</vs-table>
 <div style="height: 50px;" id="div-with-loading" class="vs-con-loading__container"></div>

 
<vs-popup class="holamundo" title="Actualizar Subsidio" :active.sync="popupEditSubsidio">
  <div class="vx-row">
       <div class="vx-col w-full mb-2">
      <label class="mt-8" for="">Montante(Mt)</label>
      <vs-input  class="w-full mt-2 mb-5" v-model="dado.pivot.amount" type="number" />
      </div>
      
 <div class="vx-col w-full mb-2">
<div class="flex flex-wrap items-center flex-start">
      <vs-button class="ml-auto mt-2" @click="updateComponent">Actualizar</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>
</div>
      
    </div>
    </div>
    </vs-popup>

<vs-popup class="holamundo" title="Adicionar Subsídio" :active.sync="popupAddSubsidio">
<div class="vx-row">

       

<div class="vx-col w-full mb-2">
      <div class="form-group" v-for="(input,k) in inputs" :key="k">

<div class="vx-col w-full">
  <label>Salário Base</label>
  <vs-input class="w-full mb-2" v-model="employee.basic_salary" disabled></vs-input>
</div>

      <div class="vx-col w-full">
      
      <label for="">Subsídio</label>
            <v-select
      name="componente"
              v-validate="'required'"
                v-model="input.component_id"
                
                :reduce="(options) => options.id"
                :options="arrayObjSubsidio"
              >
              </v-select>
              <span class="text-danger text-sm"  v-show="errors.has('componente')">{{ errors.first('componente') }}</span>
   </div>
     <div class="vx-col w-full">
   <!-- <input type="text" class="form-control" v-model="input.id"> -->
    <label for="" class="mt-5">Valor</label>
     <vs-input class="w-full  mb-2"  type="number" v-model="input.amount" name="valor"  v-validate="'required|numeric'"
                />
                   <span class="text-danger text-sm"  v-show="errors.has('valor')">{{ errors.first('valor') }}</span>
   </div>
   <span>
      <div class="flex flex-wrap items-center flex-start">
      <vs-button  class="ml-auto mt-2" size="small" ic  on-pack="feather" icon="icon-plus"  @click="add(k)" v-show="k == inputs.length-1"></vs-button>

        <vs-button class="ml-4 mt-2" type="border" color="warning" size="small" icon-pack="feather" icon="icon-trash" @click="remove(k)" v-show="k || ( !k && inputs.length > 1)"></vs-button>
    
    </div>
    </span>
    <vs-divider></vs-divider>
  </div>
  </div>
  <!-- <button @click="addCandidate">
    gravar
  </button> -->

 <div class="vx-col w-full mb-2">
<div class="flex flex-wrap items-center flex-start">
      <vs-button class="ml-auto mt-2" @click="saveComponent">Salvar</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>
</div>
      
    </div>
    </div>
    </vs-popup>
    </div>

    <vs-tabs>
   

 
    
   
  </vs-tabs>
    

    
 <vs-popup class="holamundo" title="Renovações anteriores" :active.sync="popupVerRenovacao">
  
   <vs-table  stripe :data="contract.renews">

  <template slot="thead">

    <vs-th sort-key="status">Estado</vs-th>
    <vs-th sort-key="type">Tipo de contrato</vs-th>
    <vs-th sort-key="start_date">Data de inicio</vs-th>
    <vs-th sort-key="expiry_date">Data de Término</vs-th>
    <!-- <vs-th sort-key="id">Nro</vs-th> -->
    

  </template>

  <template slot-scope="{data}">
    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
<vs-td :data="data[indextr].status">
        {{ data[indextr].status }}
      </vs-td>
      <vs-td :data="data[indextr].type">

          <span v-if="data[indextr].type==1">Prazo Certo</span>
         <span v-if="data[indextr].type==2">Prazo Incerto</span>
          <span v-if="data[indextr].type==3">Indeterminado</span>
           <span v-if="data[indextr].type==4">Estagio</span>
      </vs-td>
  
      <vs-td :data="data[indextr].start_date">
        {{ data[indextr].start_date }}
      </vs-td>
       <vs-td :data="data[indextr].expiry_date">
        {{ data[indextr].expiry_date }}
      </vs-td>
      

    </vs-tr>
  </template>
</vs-table>


    </vs-popup>

     <vs-popup class="holamundo" title="Adicionar Contacto" :active.sync="popupContactos">
 
      <vs-popup class="holamundo" title="Adicionar Contacto" :active.sync="popupContactos">
 

              
        <label class="mt-8" for="">Telefone</label>
        <vs-input  class="w-full mt-2 mb-5"  type="number"  v-model="novoContacto" />
        
    
  <div class="flex flex-wrap items-center flex-start">
        <vs-button class="ml-auto mt-2"  @click="saveContact">Salvar</vs-button>
        <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>
  
        
      </div>
      </vs-popup>
              
      <label class="mt-8" for="">Telefone</label>
      <vs-input  class="w-full mt-2 mb-5"  type="number"  v-model="novoContacto" />
      
  
<div class="flex flex-wrap items-center flex-start">
      <vs-button class="ml-auto mt-2"  @click="saveContact">Salvar</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>

      
    </div>
    </vs-popup>

 <vs-popup class="holamundo" title="Renovar Contrato" :active.sync="popupRenovar">
 

              
      <label class="mt-8" for="">Data de Início</label>
      <vs-input  class="w-full mt-2 mb-5"  type="date"  v-model="renewContract.start_date" />
      <label class="mt-8" for="">Data de Término</label>
      <vs-input  class="w-full mt-2 mb-5"  type="date"  v-model="renewContract.expiry_date" />
  
<div class="flex flex-wrap items-center flex-start">
      <vs-button class="ml-auto mt-2"  @click="saveRenovar">Renovar</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>

      
    </div>
    </vs-popup>

    <vs-popup class="holamundo" title="Alternar o estado do contrato" :active.sync="popupEstado">
          <label class="mt-8" for="">Formas de cessação de contrato</label> 
             <v-select :options="['Denunciado Pelo Funcionário','Denunciado Pela empresa','Rescindido Pela Empresa','Suspenso Pelo Funcionário','Suspenso Pela Empresa','Acordo Revogatório','Caducado']"
               v-model="contract.status" name="Grau de parentesco" v-validate="'required'"/>
      
 <div class="flex flex-wrap items-center flex-start">
      <vs-button class="ml-auto mt-2" @click="saveCessar">Cessar Contrato</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>

      
    </div>
    </vs-popup>


          </vs-tab>
          <vs-tab label="Impostos" icon-pack="feather" icon="icon-dollar-sign">
           <div class="tab-text">
         <vs-table search stripe :data="structure_components">
     
<template  slot="header">
        
          </template>
  <template slot="thead">
    <vs-th sort-key="name">Nome</vs-th>
    <vs-th sort-key="name">Abreviatura</vs-th>
    
    <vs-th></vs-th>
    

    <!-- <vs-th sort-key="birth_date">Data de Nascimento</vs-th> -->
    <vs-th></vs-th>
    <!-- <vs-th sort-key="id">Nro</vs-th> -->
  </template>

  <template slot-scope="{data}">
    <!-- <vs-tr  :key="indextr" v-for="(tr, indextr) in data">
      
      <vs-td :data="data[indextr].name">
       
        {{ data[indextr].name }}
      </vs-td>
      <vs-td :data="data[indextr].abbreviation">
       
        {{ data[indextr].abbreviation }}
      </vs-td>
       
    
    
      <vs-td :data="data[indextr].pivot.amount">
        <span v-if="data[indextr].abbreviation=='IRPS' || data[indextr].abbreviation=='INSS'">Cálculo automático </span>
       <span v-else>  {{ data[indextr].pivot.amount }}</span>
       
     </vs-td>
  
    

    
      <vs-td  :data="data[indextr].id">
        <vs-row>
                    <vs-button :disabled="data[indextr].abbreviation=='INSS' || data[indextr].abbreviation=='IRPS' " color="success" size="small" hover:text-danger type="border" icon-pack="feather" icon="icon-edit"  @click="popupOpenEditComponent(tr)">

                    </vs-button>
                    <vs-button class="ml-2" color="danger"  type="border" size="small" icon-pack="feather" icon="icon-trash" @click="openComponentConfirm(tr)"></vs-button>
             </vs-row>
            </vs-td>

    </vs-tr> -->

    <vs-tr v-for="data in structure_components" :key="document.id">
                  <template v-if="data.abbreviation=='INSS' || data.abbreviation=='IRPS'">
                <vs-td>{{data.name}}</vs-td>
              <vs-td>{{data.abbreviation}}</vs-td>
              
               <vs-td>
               
              </vs-td>
              
                <vs-td class="whitespace-no-wrap">
       <vs-row>

        <!-- <vs-button :disabled="data.abbreviation=='INSS' || data.abbreviation=='IRPS' " color="success" size="small" hover:text-danger type="border" icon-pack="feather" icon="icon-edit"  @click="popupOpenEditComponent(tr)">

        </vs-button> -->
        <vs-button class="ml-2" color="danger"  type="border" size="small" icon-pack="feather" icon="icon-trash" @click="openComponentConfirm(data)"></vs-button>
             </vs-row>
            </vs-td>
                  </template>
              
              
              </vs-tr> 

    
  </template>
</vs-table>
 <div style="height: 50px;" id="div-with-loading" class="vs-con-loading__container"></div>



<vs-popup class="holamundo" title="Adicionar Imposto" :active.sync="popupAddImposto">
<div class="vx-row">

       

<div class="vx-col w-full mb-2">
      <div class="form-group" v-for="(input,k) in inputs" :key="k">

      <div class="vx-col w-full">
      
      <label for="">Imposto</label>
            <v-select
      name="componente"
              v-validate="'required'"
                v-model="input.component_id"
                
                :reduce="(options) => options.id"
                :options="arrayObjImposto"
              >
              </v-select>
              <span class="text-danger text-sm"  v-show="errors.has('componente')">{{ errors.first('componente') }}</span>
   </div>
  
   <span>
      <!-- <div class="flex flex-wrap items-center flex-start">
      <vs-button  class="ml-auto mt-2" size="small" icon-pack="feather" icon="icon-plus"  @click="add(k)" v-show="k == inputs.length-1"></vs-button>

        <vs-button class="ml-4 mt-2" type="border" color="warning" size="small" icon-pack="feather" icon="icon-trash" @click="remove(k)" v-show="k || ( !k && inputs.length > 1)"></vs-button>
    
    </div> -->
    </span>
    <vs-divider></vs-divider>
  </div>
  </div>
  <!-- <button @click="addCandidate">
    gravar
  </button> -->

 <div class="vx-col w-full mb-2">
<div class="flex flex-wrap items-center flex-start">
      <vs-button class="ml-auto mt-2" @click="saveComponent">Salvar</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>
</div>
      
    </div>
    </div>
    </vs-popup>
    </div>

    
    

    


          </vs-tab>
  <vs-tab label="Contactos" icon-pack="feather" icon="icon-smartphone">
           <div class="tab-text">
     <vs-table stripe search :data="contacts">
<template slot="header">

          </template>
  <template stripe  slot="thead">
    <vs-th sort-key="type">Tipo de contacto</vs-th>
    <vs-th sort-key="phone">Telefone</vs-th>
    <vs-th></vs-th>
  </template>

  <template slot-scope="{data}">
    <vs-tr :key="indextr" v-for="(tr, indextr) in data">

     

   
       <vs-td v-if="data[indextr].type==1" :data="data[indextr].type">
        Principal
      </vs-td>
      <vs-td v-else :data="data[indextr].type">
        Alternativo
      </vs-td>
       <vs-td :data="data[indextr].phone">
        {{ data[indextr].phone }}
      </vs-td>
     <vs-td>
       <vs-row>
                   <vs-button :disabled="!canUpdateEmp" class="mr-3" color="success" size="small"  type="border" icon-pack="feather" icon="icon-edit" @click="popupOpenEditContacto(data)"></vs-button>

                    <vs-button :disabled="!canUpdateEmp  || data[indextr].type==1" color="danger"  type="border" size="small" icon-pack="feather" icon="icon-trash"  @click="deleteContact(data)"></vs-button>
        </vs-row>
     </vs-td>
          
       
    </vs-tr>
  </template>
</vs-table>
    </div>

   
    

    
 <vs-popup class="holamundo" title="Renovações anteriores" :active.sync="popupVerRenovacao">
   <vs-table  stripe :data="contract.renews">

  <template slot="thead">

    <vs-th sort-key="status">Estado</vs-th>
    <vs-th sort-key="type">Tipo de contrato</vs-th>
    <vs-th sort-key="start_date">Data de inicio</vs-th>
    <vs-th sort-key="expiry_date">Data de Término</vs-th>
    <!-- <vs-th sort-key="id">Nro</vs-th> -->
    

  </template>

  <template slot-scope="{data}">
    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
<vs-td :data="data[indextr].status">
        {{ data[indextr].status }}
      </vs-td>
      <vs-td :data="data[indextr].type">

          <span v-if="data[indextr].type==1">Prazo Certo</span>
         <span v-if="data[indextr].type==2">Prazo Incerto</span>
          <span v-if="data[indextr].type==3">Indeterminado</span>
           <span v-if="data[indextr].type==4">Estagio</span>
      </vs-td>
  
      <vs-td :data="data[indextr].start_date">
        {{ data[indextr].start_date }}
      </vs-td>
       <vs-td :data="data[indextr].expiry_date">
        {{ data[indextr].expiry_date }}
      </vs-td>

    </vs-tr>
  </template>
</vs-table>


    </vs-popup>

    <vs-popup class="holamundo" title="Actualizar Contacto" :active.sync="popupEditContactos">
 
<!-- {{ contacto }} -->
              
 <label class="mt-8" for="">Telefone</label>
 <vs-input  class="w-full mt-2 mb-5"  type="number"  v-model="contacto.phone" />
 

<div class="flex flex-wrap items-center flex-start">
 <vs-button class="ml-auto mt-2"  @click="updateContact">Actualizar</vs-button>
 <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>

 
</div>
</vs-popup>


     

 <vs-popup class="holamundo" title="Renovar Contrato" :active.sync="popupRenovar">
 

          <label class="mt-8" for="">Tipo de contrato</label> 
              
      <label class="mt-8" for="">Data de Início</label>
      <vs-input  class="w-full mt-2 mb-5"  type="date"  v-model="renewContract.start_date" />
      <label class="mt-8" for="">Data de Término</label>
      <vs-input  class="w-full mt-2 mb-5"  type="date"  v-model="renewContract.expiry_date" />
  
<div class="flex flex-wrap items-center flex-start">
      <vs-button class="ml-auto mt-2"  @click="saveRenovar">Renovar</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>

      
    </div>
    </vs-popup>

    <vs-popup class="holamundo" title="Alternar o estado do contrato" :active.sync="popupEstado">
          <label class="mt-8" for="">Formas de cessação de contrato</label> 
             <v-select :options="['Denunciado Pelo Funcionário','Denunciado Pela empresa','Rescindido Pela Empresa','Rescindido Pelo Funcionário','Suspenso Pelo Funcionário','Suspenso Pela Empresa','Acordo Revogatório','Caducado']"
               v-model="contract.status" name="Grau de parentesco" v-validate="'required'"/>
      
 <div class="flex flex-wrap items-center flex-start">
      <vs-button class="ml-auto mt-2" @click="saveCessar">Cessar Contrato</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>

      
    </div>
    </vs-popup>


          </vs-tab>
          <vs-tab label="Contratos" icon-pack="feather" icon="icon-file">
           <div class="tab-text">
     <vs-table stripe search :data="contracts">
<template slot="header">

          </template>
  <template stripe  slot="thead">
    <vs-th sort-key="type">Tipo de contrato</vs-th>
    <vs-th sort-key="start_date">Data de Inicio</vs-th>
    <vs-th sort-key="expiry_date">Data de termino</vs-th>
    <vs-th sort-key="renewals_number">Renovações</vs-th>
    <vs-th sort-key="status">Estado</vs-th>
    <vs-th sort-key="status">Anexo</vs-th>
    <vs-th sort-key="status"></vs-th>
    <vs-th></vs-th>
    <vs-th></vs-th>

    <vs-th></vs-th>
  </template>

  <template slot-scope="{data}">
    <vs-tr :key="indextr" v-for="(tr, indextr) in data">

     

      <vs-td :data="data[indextr].type">
        <span v-if="data[indextr].type==1">Prazo Certo</span>
         <span v-if="data[indextr].type==2">Prazo Incerto</span>
          <span v-if="data[indextr].type==3">Indeterminado</span>
           <span v-if="data[indextr].type==4">Estagio</span>
      </vs-td>
       <vs-td :data="data[indextr].start_date">
        {{ data[indextr].start_date }}
      </vs-td>
       <vs-td :data="data[indextr].expiry_date">
        {{ data[indextr].expiry_date }}
      </vs-td>
       <vs-td :data="data[indextr].renewals_number">
            {{ data[indextr].renewals_number }}
      </vs-td>
      <vs-td :data="data[indextr].status">
        {{ data[indextr].status }}
      </vs-td>
      <vs-td :data="data[indextr].attachment">
        <a :href="data[indextr].attachment" download target="_blank"> <i class="fa fa-download"></i> Baixar</a>
      </vs-td>
 <vs-td class="whitespace-no-wrap" :data="data[indextr].id">
       <vs-row>
              <vs-button :disabled="!canUpdateEmp" color="danger" type="border" size="small" @click="popupCessar(tr)">
                Cessar
              </vs-button>
               
             </vs-row>
            </vs-td>
             <vs-td class="whitespace-no-wrap" :data="data[indextr].id">
       <vs-row>
              <vs-button :disabled="data[indextr].renewals_number==2 || data[indextr].type==3 || !canUpdateEmp" color="success" type="border" size="small" @click="popupRenovarContrato(tr)">
                Renovar
              </vs-button>
               
             </vs-row>
            </vs-td>
             <vs-td class="whitespace-no-wrap" :data="data[indextr].id">
       <vs-row>
              <vs-button :disabled="!canUpdateEmp" color="primary" type="border" size="small" @click="popupVerRenovacoes(tr)">
                <i class="fa fa-eye"></i>
              </vs-button>
               
             </vs-row>
            </vs-td>
          
       
    </vs-tr>
  </template>
</vs-table>
    </div>

    <vs-tabs>
   

 
    
   
  </vs-tabs>
    

    
 <vs-popup class="holamundo" title="Renovações anteriores" :active.sync="popupVerRenovacao">
   <vs-table  stripe :data="contract.renews">

  <template slot="thead">

    <vs-th sort-key="status">Estado</vs-th>
    <vs-th sort-key="type">Tipo de contrato</vs-th>
    <vs-th sort-key="start_date">Data de inicio</vs-th>
    <vs-th sort-key="expiry_date">Data de Termino</vs-th>
    <!-- <vs-th sort-key="id">Nro</vs-th> -->
    

  </template>

  <template slot-scope="{data}">
    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
<vs-td :data="data[indextr].status">
        {{ data[indextr].status }}
      </vs-td>
      <vs-td :data="data[indextr].type">

          <span v-if="data[indextr].type==1">Prazo Certo</span>
         <span v-if="data[indextr].type==2">Prazo Incerto</span>
          <span v-if="data[indextr].type==3">Indeterminado</span>
           <span v-if="data[indextr].type==4">Estagio</span>
      </vs-td>
  
      <vs-td :data="data[indextr].start_date">
        {{ data[indextr].start_date }}
      </vs-td>
       <vs-td :data="data[indextr].expiry_date">
        {{ data[indextr].expiry_date }}
      </vs-td>

    </vs-tr>
  </template>
</vs-table>


    </vs-popup>

 <vs-popup class="holamundo" title="Renovar Contrato" :active.sync="popupRenovar">
 

          <label class="mt-8" for="">Tipo de contrato</label> 
              
      <label class="mt-8" for="">Data de Inicio</label>
      <vs-input  class="w-full mt-2 mb-5"  type="date"  v-model="renewContract.start_date" />
      <label class="mt-8" for="">Data de Termino</label>
      <vs-input  class="w-full mt-2 mb-5"  type="date"  v-model="renewContract.expiry_date" />
  
<div class="flex flex-wrap items-center flex-start">
      <vs-button class="ml-auto mt-2"  @click="saveRenovar">Renovar</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>

      
    </div>
    </vs-popup>

    <vs-popup class="holamundo" title="Alternar o estado do contrato" :active.sync="popupEstado">
          <label class="mt-8" for="">Formas de cessação de contrato</label> 
             <v-select :options="['Denunciado Pelo Funcionario','Denunciado Pela empresa','Rescindido Pela Empresa','Rescindido Pelo Funcionario','Suspenso Pelo Funcionario','Suspenso Pela Empresa','Acordo Revogatorio','Caducado']"
               v-model="contract.status" name="Grau de parentesco" v-validate="'required'"/>
      
 <div class="flex flex-wrap items-center flex-start">
      <vs-button class="ml-auto mt-2" @click="saveCessar">Cessar Contrato</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>

      
    </div>
    </vs-popup>

    <vs-popup class="holamundo" title="Adicionar Contrato" :active.sync="popupContratos">
      <form action=""  enctype="multipart/form-data">
          <label class="mt-8" for="">Tipo de contrato</label> 
              <select  class="mb-2 block w-full pl-3 pr-10 py-4 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed" v-validate="'excluded:1,2,3'"
                v-model="contracts.type" name="not_in_field" data-vv-as="selected">
    <option  value="1">Prazo certo</option>
    <option  value="2">Prazo Incerto</option>
    <option  value="3">Indeterminado</option>
    <option  value="4">Estagio</option>
  </select>
      
       <label class="mt-8" for="">Data de Inicio</label>
      <vs-input class="w-full mt-2 mb-5"  type="date"  v-model="contracts.start_date" />
      <label class="mt-8" for="">Data de Termino</label>
      <vs-input :disabled="contracts.type==3 || contracts.type==2" class="w-full mt-2 mb-5"  type="date"  v-model="contracts.expiry_date" />
      <label class="mt-8" for="">Renovacoes</label>
      <vs-input :disabled="contracts.type==3 || contracts.type==2" class="w-full mt-2 mb-5" placeholder="Preencha o numero de renovacoes caso tenha renovacoes anteriores" type="number"  v-model="contracts.renewals_number" />

      <label class="mt-8" for="">Anexo</label>
     <vs-input class="w-full mt-2 mb-5"  type="file" name="file" v-model="ficheiro2" @change="previewImage" />
<div class="flex flex-wrap items-center flex-start">
      <vs-button class="ml-auto mt-2" @click="saveContracts">Salvar</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>

      
    </div>
    </form>
    </vs-popup>
          </vs-tab>
          
           
        
        </vs-tabs>

      </div>

    </vx-card>
      <vx-card class="mt-5">
            <vs-collapse type="margin" accordion  >
           
  <vs-collapse-item >

    


                <div slot="header"><h4 class="text-primary "> 
                  <i class="fas fa-books mr-4"></i>
                  Documentos (Anexos)</h4></div>

                 <vx-card no-shadow>

 
    <div class="flex flex-wrap items-center justify-end">
  

      
    </div>

    <vs-tabs>
  <vs-tab label="Documentos Pessoais">
    <div class="tab-text mt-5">
 <vs-table stripe>
            <vs-th>Nome</vs-th>
            <vs-th>Numero</vs-th> 
            <vs-th>Data de emissão</vs-th> 
            <vs-th>Válido ate</vs-th> 
            <vs-th>Download</vs-th> 
            
                <vs-tr v-for="document in documents" :key="document.id">
                  <template v-if="document.type==='1'">
                <vs-td>{{document.name}}</vs-td>
              <vs-td>{{document.number}}</vs-td>
              <vs-td>{{document.issue_date}}</vs-td>
              <vs-td>{{document.expiry_date}}</vs-td>
               <vs-td>
               <a :href="document.attachment" download target="_blank"> <i class="fa fa-download"></i> DOWNLOAD</a>

              </vs-td>
              
                <vs-td class="whitespace-no-wrap">
       <vs-row>
                   <vs-button class="mr-3" color="success" size="small"  type="border" icon-pack="feather" icon="icon-edit" @click="openUpdateDocument(document)"></vs-button>

                    <vs-button color="danger"  type="border" size="small" icon-pack="feather" icon="icon-trash" ></vs-button>
             </vs-row>
            </vs-td>
                  </template>
              
              
              </vs-tr> 
           
            
    </vs-table>
    </div>
  </vs-tab>


     <vs-tab label="Adendas">
     <div class="tab-text mt-5">
 <vs-table stripe>
            <vs-th>Nome</vs-th>
            <vs-th>Número</vs-th> 
            <vs-th>Válido até</vs-th> 
            <vs-th>Download</vs-th> 
            
                <vs-tr v-for="document in documents" :key="document.id">
                  <template v-if="document.type==='3'">
                <vs-td>{{document.name}}</vs-td>
              <vs-td>{{document.number}}</vs-td>
              <vs-td>{{document.expiry_date}}</vs-td>
               <vs-td>
               <a :href="document.attachment" download target="_blank"> <i class="fa fa-download"></i> DOWNLOAD</a>

              </vs-td>
              
                <vs-td class="whitespace-no-wrap">
       <vs-row>
             <vs-button class="mr-3" color="success" size="small"  type="border" icon-pack="feather" icon="icon-edit" @click="openUpdateDocument(document)"></vs-button>

                    <vs-button color="danger"  type="border" size="small" icon-pack="feather" icon="icon-trash" ></vs-button>
             </vs-row>
            </vs-td>
                  </template>
              
              
              </vs-tr> 
           
            
    </vs-table>
    </div>
    </vs-tab>
     <vs-tab label="Outros">
     <div class="tab-text mt-5">
 <vs-table stripe>
            <vs-th>Nome</vs-th>
            <vs-th>Número</vs-th> 
            <vs-th>Válido até</vs-th> 
            <vs-th>Download</vs-th> 
            
                <vs-tr v-for="document in documents" :key="document.id">
                  <template v-if="document.type==='4'">
                <vs-td>{{document.name}}</vs-td>
              <vs-td>{{document.number}}</vs-td>
              <vs-td>{{document.expiry_date}}</vs-td>
               <vs-td>
               <a :href="document.attachment" download target="_blank"> <i class="fa fa-download"></i> DOWNLOAD</a>

              </vs-td>
              
                <vs-td class="whitespace-no-wrap">
       <vs-row>
                    <vs-button class="mr-3" color="success" size="small"  type="border" icon-pack="feather" icon="icon-edit" @click="openUpdateDocument(document)"></vs-button>

                    <vs-button color="danger"  type="border" size="small" icon-pack="feather" icon="icon-trash" ></vs-button>
             </vs-row>
            </vs-td>
                  </template>
              
              
              </vs-tr> 
           
            
    </vs-table>
    </div>
    </vs-tab>
  </vs-tabs>
    

    <vs-popup class="holamundo" title="Adicionar Documento" :active.sync="popupDocument">
      <form action=""  enctype="multipart/form-data">
      <label class="mt-8" for="">Tipo de documento</label>
      <select  class="block w-full pl-3 pr-10 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed" 
        v-model="documents.type" >
    <option  value="1">Documentos Pessoais</option>
    <!-- <option  value="2">Processos</option> -->
    <option  value="3">Adendas</option>
    <option  value="4">Outros</option>
  </select>
  
          <label class="mt-8" for="">Nome</label>
      <vs-input class="w-full mt-2 mb-5"  type="text"  v-model="documents.name" />
      <label class="mt-8" for="">Numero</label>
      <vs-input class="w-full mt-2 mb-5"  type="text"  v-model="documents.number" />
      <label class="mt-8" for="">Data de emissão</label>
      <vs-input class="w-full mt-2 mb-5"  type="date"  v-model="documents.issue_date" />
      <label class="mt-8" for="">Valido ate</label>
      <vs-input class="w-full mt-2 mb-5"  type="date"  v-model="documents.expiry_date" />
      <label class="mt-8" for="">Carregar o documento</label>
      <vs-input class="w-full mt-2 mb-5"  type="file" name="file" v-model="ficheiro3" @change="previewImage" />

<div class="flex flex-wrap items-center flex-start">
      <vs-button class="ml-auto mt-2" @click="saveDocument">Salvar</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>

      
    </div>
    </form>
    </vs-popup>

    <vs-popup class="holamundo" title="Actualizar Documento" :active.sync="popupUpdateDocument">
      <form action=""  enctype="multipart/form-data">
      <label class="mt-8" for="">Tipo de documento</label>
      <select  class="block w-full pl-3 pr-10 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed" 
        v-model="document.type" >
    <option  value="1">Documentos Pessoais</option>
    <option  value="2">Processos</option>
    <option  value="3">Contratos e Adendas</option>
    <option  value="4">Outros</option>
  </select>
  
          <label class="mt-8" for="">Nome</label>
      <vs-input class="w-full mt-2 mb-5"  type="text"  v-model="document.name" />
      <label class="mt-8" for="">Número</label>
      <vs-input class="w-full mt-2 mb-5"  type="text"  v-model="document.number" />
      <label class="mt-8" for="">Válido até</label>
      <vs-input class="w-full mt-2 mb-5"  type="date"  v-model="document.expiry_date" />
      <label class="mt-8" for="">Carregar o documento</label>
      <vs-input class="w-full mt-2 mb-5"  type="file" name="file" v-model="ficheiro8" @change="previewImage" />

<div class="flex flex-wrap items-center flex-start">
      <vs-button class="ml-auto mt-2" @click="updateDocument">Actualizar</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>

      
    </div>
    </form>
    </vs-popup>
  </vx-card>
            </vs-collapse-item>
            <vs-collapse-item >

    


              <div slot="header"><h4 class="text-primary "> 
                <i class="fas fa-file mr-4"></i>
                Processos</h4></div>
              
               <vx-card no-shadow>
              
              
              <div class="flex flex-wrap items-center justify-end">
              
              <vs-popup class="holamundo" title="Adicionar Processo" :active.sync="popupProcess">
              <form action=""  enctype="multipart/form-data">
              <label class="mt-8" for="">Tipo de processo</label>
              <select  class="block w-full pl-3 pr-10 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed" 
              v-model="documents.type" >
              <option  value="adomestacao">Adomestacão</option>
    <option  value="repreensao">Repreensão</option>
    <option  value="disciplinar">Processo disciplinar</option>
              </select>
              
              <label class="mt-8" for="">Infracção</label>
              <vs-input class="w-full mt-2 mb-5"  type="text"  v-model="documents.name" />
              <label class="mt-8" for="">Data de inicio</label>
              <vs-input class="w-full mt-2 mb-5"  type="text"  v-model="documents.number" />
              <label class="mt-8" for="">Data de termino</label>
              <vs-input class="w-full mt-2 mb-5"  type="date"  v-model="documents.expiry_date" />
              <label class="mt-8" for="">Carregar o documento</label>
              <vs-input class="w-full mt-2 mb-5"  type="file" name="file" v-model="ficheiro4" @change="previewImage" />
              
              <div class="flex flex-wrap items-center flex-start">
              <vs-button class="ml-auto mt-2" @click="saveProcess">Salvar</vs-button>
              <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>
              
              
              </div>
              </form>
              </vs-popup>
              
              </div>
              
              <vs-tabs>
              <vs-tab label="Adomestacão">
              <div class="tab-text mt-5">
              <vs-table stripe>
              <vs-th>Tipo</vs-th>
              <vs-th>Infracção</vs-th> 
              <vs-th>Data de inicio</vs-th> 
              <vs-th>Data de termino</vs-th> 
              <vs-th>Documento</vs-th> 
              
              <vs-tr v-for="document in documents" :key="document.id">
                <template v-if="document.type==='1'">
              <vs-td>{{document.name}}</vs-td>
              <vs-td>{{document.number}}</vs-td>
              <vs-td>{{document.expiry_date}}</vs-td>
              <vs-td>
              <a :href="document.attachment" download target="_blank"> <i class="fa fa-download"></i> DOWNLOAD</a>
              
              </vs-td>
              
              <vs-td class="whitespace-no-wrap">
              <vs-row>
                 <vs-button class="mr-3" color="success" size="small"  type="border" icon-pack="feather" icon="icon-edit" @click="openUpdateDocument(document)"></vs-button>
              
                  <vs-button color="danger"  type="border" size="small" icon-pack="feather" icon="icon-trash" ></vs-button>
              </vs-row>
              </vs-td>
                </template>
              
              
              </vs-tr> 
              
              
              </vs-table>
              </div>
              </vs-tab>
              
              
              <vs-tab label="Repreensão">
              <div class="tab-text mt-5">
              <vs-table stripe>
                <vs-th>Tipo</vs-th>
              <vs-th>Infracção</vs-th> 
              <vs-th>Data de inicio</vs-th> 
              <vs-th>Data de termino</vs-th> 
              <vs-th>Documento</vs-th> 
              
              <vs-tr v-for="document in documents" :key="document.id">
                <template v-if="document.type==='3'">
              <vs-td>{{document.name}}</vs-td>
              <vs-td>{{document.number}}</vs-td>
              <vs-td>{{document.expiry_date}}</vs-td>
              <vs-td>
              <a :href="document.attachment" download target="_blank"> <i class="fa fa-download"></i> DOWNLOAD</a>
              
              </vs-td>
              
              <vs-td class="whitespace-no-wrap">
              <vs-row>
              <vs-button class="mr-3" color="success" size="small"  type="border" icon-pack="feather" icon="icon-edit" @click="openUpdateDocument(document)"></vs-button>
              
                  <vs-button color="danger"  type="border" size="small" icon-pack="feather" icon="icon-trash" ></vs-button>
              </vs-row>
              </vs-td>
                </template>
              
              
              </vs-tr> 
              
              
              </vs-table>
              </div>
              </vs-tab>
              <vs-tab label="Processo disciplinar">
              <div class="tab-text mt-5">
              <vs-table stripe>
                <vs-th>Tipo</vs-th>
                <vs-th>Infracção</vs-th> 
              <vs-th>Data de inicio</vs-th> 
              <vs-th>Data de termino</vs-th> 
              <vs-th>Documento</vs-th> 
              
              <vs-tr v-for="document in documents" :key="document.id">
                <template v-if="document.type==='4'">
              <vs-td>{{document.name}}</vs-td>
              <vs-td>{{document.number}}</vs-td>
              <vs-td>{{document.expiry_date}}</vs-td>
              <vs-td>
              <a :href="document.attachment" download target="_blank"> <i class="fa fa-download"></i> DOWNLOAD</a>
              
              </vs-td>
              
              <vs-td class="whitespace-no-wrap">
              <vs-row>
                  <vs-button class="mr-3" color="success" size="small"  type="border" icon-pack="feather" icon="icon-edit" @click="openUpdateDocument(document)"></vs-button>
              
                  <vs-button color="danger"  type="border" size="small" icon-pack="feather" icon="icon-trash" ></vs-button>
              </vs-row>
              </vs-td>
                </template>
              
              
              </vs-tr> 
              
              
              </vs-table>
              </div>
              </vs-tab>
              </vs-tabs>
              
              
              <vs-popup class="holamundo" title="Adicionar Documento" :active.sync="popupDocument">
              <form action=""  enctype="multipart/form-data">
              <label class="mt-8" for="">Tipo de documento</label>
              <select  class="block w-full pl-3 pr-10 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed" 
              v-model="documents.type" >
              <option  value="1">Documentos Pessoais</option>
              <option  value="2">Processos</option>
              <option  value="3">Contratos e Adendas</option>
              <option  value="4">Outros</option>
              </select>
              
              <label class="mt-8" for="">Nome</label>
              <vs-input class="w-full mt-2 mb-5"  type="text"  v-model="documents.name" />
              <label class="mt-8" for="">Numero</label>
              <vs-input class="w-full mt-2 mb-5"  type="text"  v-model="documents.number" />
              <label class="mt-8" for="">Valido ate</label>
              <vs-input class="w-full mt-2 mb-5"  type="date"  v-model="documents.expiry_date" />
              <label class="mt-8" for="">Carregar o documento</label>
              <vs-input class="w-full mt-2 mb-5"  type="file" name="file" v-model="ficheiro6" @change="previewImage" />
              
              <div class="flex flex-wrap items-center flex-start">
              <vs-button class="ml-auto mt-2" @click="saveDocument">Salvar</vs-button>
              <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>
              
              
              </div>
              </form>
              </vs-popup>
              
              <vs-popup class="holamundo" title="Actualizar Documento" :active.sync="popupUpdateDocument">
              <form action=""  enctype="multipart/form-data">
              <label class="mt-8" for="">Tipo de documento</label>
              <select  class="block w-full pl-3 pr-10 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed" 
              v-model="document.type" >
              <option  value="1">Documentos Pessoais</option>
              <option  value="2">Processos</option>
              <option  value="3">Contratos e Adendas</option>
              <option  value="4">Outros</option>
              </select>
              
              <label class="mt-8" for="">Nome</label>
              <vs-input class="w-full mt-2 mb-5"  type="text"  v-model="document.name" />
              <label class="mt-8" for="">Número</label>
              <vs-input class="w-full mt-2 mb-5"  type="text"  v-model="document.number" />
              <label class="mt-8" for="">Válido até</label>
              <vs-input class="w-full mt-2 mb-5"  type="date"  v-model="document.expiry_date" />
              <label class="mt-8" for="">Carregar o documento</label>
              <vs-input class="w-full mt-2 mb-5"  type="file" name="file" v-model="ficheiro7" @change="previewImage" />
              
              <div class="flex flex-wrap items-center flex-start">
              <vs-button class="ml-auto mt-2" @click="updateDocument">Actualizar</vs-button>
              <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>
              
              
              </div>
              </form>
              </vs-popup>
              </vx-card>
              </vs-collapse-item>
                            
               <vs-collapse-item >

                 <div slot="header"><h4 class="text-primary ">
                  <i class="fad fa-briefcase mr-4"></i>
                   Experiência de Trabalho</h4> </div>

                 <vx-card no-shadow>

 
    <div class="flex flex-wrap items-center justify-end">
  
      
    </div>
   
    <vs-table search stripe :data="work_experiences">
<template slot="header">

          </template>
  <template slot="thead">
    <vs-th sort-key="company_name">Nome da empresa</vs-th>
    <vs-th sort-key="address">Endereço</vs-th>
    <vs-th sort-key="position">Função</vs-th>
    <vs-th sort-key="start_date">Data de início</vs-th>
     <vs-th sort-key="end_date">Data de término</vs-th>
    <vs-th></vs-th>
    <!-- <vs-th sort-key="id">Nro</vs-th> -->
  </template>

  <template slot-scope="{data}">
    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
<vs-td :data="data[indextr].company_name">
        {{ data[indextr].company_name }}
      </vs-td>
  
      

      <vs-td :data="data[indextr].address">
        {{ data[indextr].address }}
      </vs-td>

 <vs-td :data="data[indextr].position">
        {{ data[indextr].position }}
      </vs-td>

       <vs-td :data="data[indextr].start_date">
        {{ data[indextr].start_date }}
      </vs-td>

       <vs-td :data="data[indextr].end_date">
        {{ data[indextr].end_date }}
      </vs-td>
    <vs-td class="whitespace-no-wrap" :data="data[indextr].id">
       <vs-row>
                    <vs-button class="mr-3" color="success"  type="border" icon-pack="feather" icon="icon-edit" @click="openWorkExperience(tr)"></vs-button>

                    <vs-button color="danger"  type="border" icon-pack="feather" icon="icon-trash" @click="deleteWorkExperience(tr)"></vs-button>
             </vs-row>
            </vs-td>

   
    </vs-tr>
  </template>
</vs-table>

    <vs-popup class="holamundo" title="Adicionar Experiencia de trabalho " :active.sync="popupWorkExperience">
    

       <div class="vx-row" >
          <div class="vx-col sm:w-4/4 w-full mb-2">
            <div class="vx-col w-full">
              <label for="">Nome da empresa</label>
              <vs-input
                class="w-full"
                icon-pack="feather"
                icon="icon-check"
                icon-no-border
                v-model="company_name"
              />
            </div>
          </div>
           <div class="vx-col sm:w-4/4 w-full mb-2">
            <div class="vx-col w-full">
              <label for="">Endereço</label>
              <vs-input
                class="w-full"
                icon-pack="feather"
                icon="icon-check"
                icon-no-border
                v-model="address"
              />
            </div>
          </div>
           <div class="vx-col sm:w-4/4 w-full mb-2">
            <div class="vx-col w-full">
              <label for="">Posição</label>
              <vs-input
                class="w-full"
                icon-pack="feather"
                icon="icon-check"
                icon-no-border
                v-model="position"
              />
            </div>
          </div>
           <div class="vx-col sm:w-4/4 w-full mb-2">
            <div class="vx-col w-full">
               <label for="">Data de Inicio</label>
              <vs-input
              type="date"
                class="w-full"
                icon-pack="feather"
                icon="icon-check"
                icon-no-border
                v-model="start_date"
              />
            </div>
          </div>
          <div class="vx-col sm:w-4/4 w-full mb-2">
            <div class="vx-col w-full">
               <label for="">Data de Termino</label>
              <vs-input
              type="date"
                class="w-full"
                icon-pack="feather"
                icon="icon-check"
                icon-no-border
                v-model="end_date"
              />
            </div>
          </div>
         
        </div>
                <!-- <div id=app>
  <div class="form-group" v-for="(input,k) in inputs" :key="k">
    <input type="text" class="form-control" v-model="input.name">
    <input type="text" class="form-control" v-model="input.party">
    <span>
      <i class="fas fa-minus-circle" @click="remove(k)" v-show="k || ( !k && inputs.length > 1)">Remove</i>
      <i class="fas fa-plus-circle" @click="add(k)" v-show="k == inputs.length-1">Add fields</i>
    </span>
  </div>
  <button @click="addCandidate">
    Submit
  </button>
</div> -->
<div class="flex flex-wrap items-center flex-start">
      <vs-button class="ml-auto mt-2" @click="saveWorkExperience">Salvar</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>

      
    </div>
    </vs-popup>
    
<vs-popup class="holamundo" title="Actualizar Experiencia de trabalho " :active.sync="popupUpdateWorkExperience">
    

       <div class="vx-row" >
          <div class="vx-col sm:w-4/4 w-full mb-2">
            <div class="vx-col w-full">
              <label for="">Nome da empresa</label>
              <vs-input
                class="w-full"
                icon-pack="feather"
                icon="icon-check"
                icon-no-border
                v-model="work_experience.company_name"
              />
            </div>
          </div>
           <div class="vx-col sm:w-4/4 w-full mb-2">
            <div class="vx-col w-full">
              <label for="">Endereço</label>
              <vs-input
                class="w-full"
                icon-pack="feather"
                icon="icon-check"
                icon-no-border
                v-model="work_experience.address"
              />
            </div>
          </div>
           <div class="vx-col sm:w-4/4 w-full mb-2">
            <div class="vx-col w-full">
              <label for="">Posição</label>
              <vs-input
                class="w-full"
                icon-pack="feather"
                icon="icon-check"
                icon-no-border
                v-model="work_experience.position"
              />
            </div>
          </div>
           <div class="vx-col sm:w-4/4 w-full mb-2">
            <div class="vx-col w-full">
               <label for="">Data de Inicio</label>
              <vs-input
              type="date"
                class="w-full"
                icon-pack="feather"
                icon="icon-check"
                icon-no-border
                v-model="work_experience.start_date"
              />
            </div>
          </div>
          <div class="vx-col sm:w-4/4 w-full mb-2">
            <div class="vx-col w-full">
               <label for="">Data de Termino</label>
              <vs-input
              type="date"
                class="w-full"
                icon-pack="feather"
                icon="icon-check"
                icon-no-border
                v-model="work_experience.end_date"
              />
            </div>
          </div>
         
        </div>
           
<div class="flex flex-wrap items-center flex-start">
      <vs-button class="ml-auto mt-2" @click="updateWorkExperience">Actualizar</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>

      
    </div>
    </vs-popup>

  </vx-card>
            </vs-collapse-item>


  <vs-collapse-item >

                <div slot="header"><h4 class="text-primary ">
                  <i class="fad fa-graduation-cap mr-4"></i>
                   Formação Acadêmica</h4> </div>

                 <vx-card no-shadow>

 
    <div class="flex flex-wrap items-center justify-end">
  
      
    </div>
    <vs-table search stripe :data="educations">
<template slot="header">

          </template>
  <template slot="thead">
    <vs-th sort-key="school_name">Instituição de ensino</vs-th>
    <vs-th sort-key="level">Nível</vs-th>
    <vs-th sort-key="course">Formação</vs-th>
    <vs-th sort-key="conclusion_year">Data de Conclusão</vs-th>
    <vs-th></vs-th>
    <!-- <vs-th sort-key="id">Nro</vs-th> -->
  </template>

  <template slot-scope="{data}">
    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
<vs-td :data="data[indextr].school_name">
        {{ data[indextr].school_name }}
      </vs-td>
  
      <vs-td :data="data[indextr].level">
        {{ data[indextr].level }}
      </vs-td>
       <vs-td :data="data[indextr].course">
        {{ data[indextr].course }}
      </vs-td>

 <vs-td :data="data[indextr].conclusion_year">
        {{ data[indextr].conclusion_year }}
      </vs-td>

      
      <vs-td class="whitespace-no-wrap" :data="data[indextr].id">
       <vs-row>
                    <vs-button class="mr-3" color="success"  type="border" icon-pack="feather" icon="icon-edit" @click="openUpdateEducations(tr)"></vs-button>

                    <vs-button color="danger"  type="border" icon-pack="feather" icon="icon-trash" @click="deleteEducations(tr)"></vs-button>
             </vs-row>
              <!-- <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" /> -->
            </vs-td>

      <!-- <vs-td :data="data[indextr].id">
        {{ data[indextr].id }}
      </vs-td> -->
    </vs-tr>
  </template>
</vs-table>

    <vs-popup class="holamundo" title="Adicionar Formacao Academica " :active.sync="popupEducations">
    

       <div class="vx-row" >
          <div class="vx-col sm:w-4/4 w-full mb-2">
            <div class="vx-col w-full">
              <label for="">Instituição de ensino</label>
              <vs-input
                class="w-full"
                icon-pack="feather"
                icon="icon-check"
                icon-no-border
                v-model="school_name"
              />
            </div>
          </div>
           <div class="vx-col sm:w-4/4 w-full mb-2">
            <div class="vx-col w-full">
              <label for="">Nivel</label>
              <vs-input
                class="w-full"
                icon-pack="feather"
                icon="icon-check"
                icon-no-border
                v-model="level"
              />
            </div>
          </div>
          <div class="vx-col sm:w-4/4 w-full mb-2">
            <div class="vx-col w-full">
              <label for="">Formação</label>
              <vs-input
                class="w-full"
                icon-pack="feather"
                icon="icon-check"
                icon-no-border
                v-model="course"
              />
            </div>
          </div>
           <div class="vx-col sm:w-4/4 w-full mb-2">
            <div class="vx-col w-full">
              <label for="">Data de Conclusão</label>
              <vs-input
                class="w-full"
                icon-pack="feather"
                icon="icon-check"
                icon-no-border
                v-model="conclusion_year"
                type="date"
              />
            </div>
          </div>
           
          
         
        </div>
          

<div class="flex flex-wrap items-center flex-start">
      <vs-button class="ml-auto mt-2" @click="saveEducation">Salvar</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>

      
    </div>
    </vs-popup>
    
<!--EDITAR-->
    <vs-popup class="holamundo" title="Actualizar Formacao Academica " :active.sync="popupUpdateEducations">
    

       <div class="vx-row" >
          <div class="vx-col sm:w-4/4 w-full mb-2">
            <div class="vx-col w-full">
              <label for="">Instituição de ensino</label>
              <vs-input
                class="w-full"
                icon-pack="feather"
                icon="icon-check"
                icon-no-border
                v-model="education.school_name"
              />
            </div>
          </div>
           <div class="vx-col sm:w-4/4 w-full mb-2">
            <div class="vx-col w-full">
              <label for="">Nivel</label>
              <vs-input
                class="w-full"
                icon-pack="feather"
                icon="icon-check"
                icon-no-border
                v-model="education.level"
              />
            </div>
          </div>
          <div class="vx-col sm:w-4/4 w-full mb-2">
            <div class="vx-col w-full">
              <label for="">Formação</label>
              <vs-input
                class="w-full"
                icon-pack="feather"
                icon="icon-check"
                icon-no-border
                v-model="education.course"
              />
            </div>
          </div>
           <div class="vx-col sm:w-4/4 w-full mb-2">
            <div class="vx-col w-full">
              <label for="">Data de Conclusão</label>
              <vs-input
                class="w-full"
                icon-pack="feather"
                icon="icon-check"
                icon-no-border
                v-model="education.conclusion_year"
                type="date"
              />
            </div>
          </div>
           
          
         
        </div>
          

<div class="flex flex-wrap items-center flex-start">
      <vs-button class="ml-auto mt-2" @click="updateEducations">Actualizar</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>

      
    </div>
    </vs-popup>
 <!--EDITAR-->

    
  </vx-card>
            </vs-collapse-item>


            <vs-collapse-item >

                <div slot="header"><h4 class="text-primary ">
                  <i class="fad fa-child mr-4"></i>
                   Dependentes</h4> </div>

                 <vx-card no-shadow>

 
    <div class="flex flex-wrap items-center justify-end">
  
      
    </div>
    <vs-table search stripe :data="dependents">
<template slot="header">

          </template>
  <template slot="thead">
    <vs-th sort-key="name">Nome</vs-th>
    <vs-th sort-key="kinship">Grau de parentesco</vs-th>
    <vs-th sort-key="birth_date">Data de Nascimento</vs-th>
    <vs-th sort-key="doc_type">Tipo de documento</vs-th>
    <vs-th sort-key="doc_number">Nr. do documento</vs-th>
    <vs-th></vs-th>
    <!-- <vs-th sort-key="id">Nro</vs-th> -->
  </template>

  <template slot-scope="{data}">
    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
<vs-td :data="data[indextr].name">
        {{ data[indextr].name }}
      </vs-td>
      <vs-td :data="data[indextr].dependenteGrau">
        {{ data[indextr].kinship }}
      </vs-td>
      
<vs-td :data="data[indextr].birth_date">
        {{ data[indextr].birth_date }}
      </vs-td>
      <vs-td :data="data[indextr].doc_type">
        {{ data[indextr].doc_type }}
      </vs-td>
      <vs-td :data="data[indextr].type">
        {{ data[indextr].doc_number }}
      </vs-td>
  

      
      

    <vs-td class="" :data="data[indextr].id">
       <vs-row>
                    <vs-button class="mr-3" color="success" size="small" type="border" icon-pack="feather" icon="icon-edit" @click="openUpdateAfiliados(tr)"></vs-button>

                    <vs-button color="danger"  type="border" size="small" icon-pack="feather" icon="icon-trash" @click="deleteAfiliados(tr)" ></vs-button>
             </vs-row>
              <!-- <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" /> -->
            </vs-td>

      <!-- <vs-td :data="data[indextr].id">
        {{ data[indextr].id }}
      </vs-td> -->
    </vs-tr>
  </template>
</vs-table>

    <vs-popup class="holamundo" title="Adicionar Dependente" :active.sync="popupAfiliados">
    

       <div class="vx-row" >
          <div class="vx-col sm:w-4/4 w-full mb-2">
            <div class="vx-col w-full">
              <label for="" class="text-sm font-bold">Nome completo</label>
              <vs-input
                class="w-full"
                icon-no-border
                v-model="dependent_name"
              />
            </div>
          </div>
           <div class="vx-col sm:w-4/4 w-full mb-2">
            <div class="vx-col w-full">
               <label for="" class="text-sm font-bold">Data de Nascimento</label>
              <vs-input
              type="date"
                class="w-full"
                icon-no-border
                v-model="dependet_birth_date"
              />
            </div>
            
          </div>
          <div class="vx-col sm:w-4/4 w-full mb-2">
            <div class="vx-col w-full">
               <label for="" class="text-sm font-bold">Grau de parentesco</label>
               <v-select :options="['Trisavô(ó)', 'Bisavô(ó)', 'Avô(ó)', 'Pai', 'Mãe','Esposa(o)','irmão(ã)', 'Filho(a)','Neto(a)','Bisneto(a)', 'Trisneto(a)', 'Sobrinho(a)',]"
               v-model="dependenteGrau" name="Grau de parentesco" v-validate="'required'"> </v-select>
            </div>
            
          </div>
          <div class="vx-col sm:w-4/4 w-full mb-2">
            <div class="vx-col w-full">
               <label for="" class="text-sm font-bold">Tipo de documento</label>
               <v-select :options="['Bilhete de Identidade','Cedula Pessoal', 'Passaporte']"
               v-model="dependent_doc_type" > </v-select>
            
          </div>
         </div>
         <div class="vx-col sm:w-4/4 w-full mb-2">
            <div class="vx-col w-full">
               <label for="" class="text-sm font-bold">Numerro de documento</label>
               <vs-input
                class="w-full"
                icon-no-border
                v-model="dependent_docNumber"
                tyoe="text"
              />
            
          </div>
         </div>
        </div>
   
<div class="flex flex-wrap items-center flex-start">
      <vs-button class="ml-auto mt-2" @click="saveDependents">Salvar</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>

      
    </div>
    </vs-popup>

    <!--EDITAR DEPENDENTE-->
     <vs-popup class="holamundo" title="Actualizar Dependente" :active.sync="popupUpdateAfiliados">
    

        <div class="vx-row" >
          <div class="vx-col sm:w-4/4 w-full mb-2">
            <div class="vx-col w-full">
              <label for="" class="text-sm font-bold">Nome completo</label>
              <vs-input
                class="w-full"
                icon-no-border
                v-model="dependent.name"
              />
            </div>
          </div>
           <div class="vx-col sm:w-4/4 w-full mb-2">
            <div class="vx-col w-full">
               <label for="" class="text-sm font-bold">Data de Nascimento</label>
              <vs-input
              type="date"
                class="w-full"
                icon-no-border
                v-model="dependent.birth_date"
              />
            </div>
            
          </div>
          <div class="vx-col sm:w-4/4 w-full mb-2">
            <div class="vx-col w-full">
               <label for="" class="text-sm font-bold">Grau de parentesco</label>
               <v-select :options="['Trisavô(ó)', 'Bisavô(ó)', 'Avô(ó)', 'Pai', 'Mãe','Esposa(o)','irmão(ã)', 'Filho(a)','Neto(a)','Bisneto(a)', 'Trisneto(a)', 'Sobrinho(a)',]"
               v-model="dependent.kinship" name="Grau de parentesco" v-validate="'required'"> </v-select>
            </div>
            
          </div>
          <div class="vx-col sm:w-4/4 w-full mb-2">
            <div class="vx-col w-full">
               <label for="" class="text-sm font-bold">Tipo de documento</label>
               <v-select :options="['Bilhete de Identidade','Cedula Pessoal', 'Passaporte']"
               v-model="dependent.doc_type" > </v-select>
            
          </div>
         </div>
         <div class="vx-col sm:w-4/4 w-full mb-2">
            <div class="vx-col w-full">
               <label for="" class="text-sm font-bold">Numerro de documento</label>
               <vs-input
                class="w-full"
                icon-no-border
                v-model="dependent.doc_number"
                tyoe="text"
              />
            
          </div>
         </div>
        </div>
<div class="flex flex-wrap items-center flex-start">
      <vs-button class="ml-auto mt-2" @click="updateAfiliados">Actualizar</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>

      
    </div>
    </vs-popup>
  </vx-card>
            </vs-collapse-item>

           
 <vs-collapse-item >

                 <div slot="header"><h4 class="text-primary ">
                  <i class="fad fa-wheelchair mr-4"></i>
                   Deficiências</h4> </div>

                 <vx-card no-shadow>

 
    <div class="flex flex-wrap items-center justify-end">
  
      
    </div>
    <vs-table search stripe :data="deficiencies">
<template slot="header">

          </template>
  <template slot="thead">
    <vs-th sort-key="description">Tipo</vs-th>
    <vs-th sort-key="description">Descrição</vs-th>
    <vs-th></vs-th>
  </template>

  <template slot-scope="{data}">
    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
      <vs-td :data="data[indextr].type">
        {{ data[indextr].type }}
      </vs-td>
<vs-td :data="data[indextr].description">
        {{ data[indextr].description }}
      </vs-td>

      
      <vs-td class="whitespace-no-wrap" :data="data[indextr].id">
       <vs-row>
                    <vs-button class="mr-3" color="success"  type="border" icon-pack="feather" icon="icon-edit" @click="openUpdateDeficiency(tr)" ></vs-button>

                    <vs-button color="danger"  type="border" icon-pack="feather" icon="icon-trash" @click="deleteDeficiency(tr)"></vs-button>
             </vs-row>
              <!-- <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" /> -->
            </vs-td>
    </vs-tr>
  </template>
</vs-table>

    <vs-popup class="holamundo" title="Adicionar Deficiência" :active.sync="popupDeficiency">
    

       <div class="vx-row">
          <div class="vx-col sm:w-4/4 w-full mb-2">
            <div class="vx-col w-full">
              <label for="">Tipo de Deficiência</label>
              <vs-input
                class="w-full"
                
                icon-no-border
                v-model="deficiency.type"
              />
            </div>
          </div>
          <div class="vx-col sm:w-4/4 w-full mb-2">
            <div class="vx-col w-full">
              <label for="">Descrição</label>
              <vs-input
                class="w-full"
                
                icon-no-border
                v-model="deficiency.description"
              />
            </div>
          </div>
          
           
          
           
          
         
        </div>
                <!-- <div id=app>
  <div class="form-group" v-for="(input,k) in inputs" :key="k">
    <input type="text" class="form-control" v-model="input.name">
    <input type="text" class="form-control" v-model="input.party">
    <span>
      <i class="fas fa-minus-circle" @click="remove(k)" v-show="k || ( !k && inputs.length > 1)">Remove</i>
      <i class="fas fa-plus-circle" @click="add(k)" v-show="k == inputs.length-1">Add fields</i>
    </span>
  </div>
  <button @click="addCandidate">
    Submit
  </button>
</div> -->
<div class="flex flex-wrap items-end flex-start">
      <vs-button class="ml-auto mt-2" @click="saveDeficiency">Salvar</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>

      
    </div>
    </vs-popup>
    <!--EDITAR-->
    <vs-popup class="holamundo" title="Actualizar Deficiência" :active.sync="popupUpdateDeficiency">
    

       <div class="vx-row">
          <div class="vx-col sm:w-4/4 w-full mb-2">
            <div class="vx-col w-full">
              <label for="">Tipo de Deficiência</label>
              <vs-input
                class="w-full"
                icon-no-border
                v-model="deficiency.type"
              />
            </div>
            
          </div>
          
          <div class="vx-col sm:w-4/4 w-full mb-2">
          <div class="vx-col w-full">
              <label for="">Descrição</label>
              <vs-input
                class="w-full"
                icon-no-border
                v-model="deficiency.description"
              />
            </div>
           </div>
          
         
        </div>

<div class="flex flex-wrap items-end flex-start">
      <vs-button class="ml-auto mt-2" @click="updateDeficiency">Atualizar</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>

      
    </div>
    </vs-popup>
<!--EDITAR-->
    
  </vx-card>
            </vs-collapse-item>

           

         

 <vs-collapse-item >

                
                <div slot="header"><h4 class="text-primary ">
                  <i class="fad fa-users mr-4"></i>
                   Agregado Familiar</h4> </div>

                 <vx-card no-shadow>

 
    <div class="flex flex-wrap items-center justify-end">
  
      
    </div>
    <vs-table search stripe :data="households">
<template slot="header">
            
          </template>
  <template slot="thead">
    <vs-th sort-key="name">Nome</vs-th>
    <vs-th sort-key="kinship">Grau de parentesco</vs-th>
    <vs-th sort-key="doc_number">Telefone</vs-th>
    <vs-th></vs-th>
    <!-- <vs-th sort-key="id">Nro</vs-th> -->
  </template>

  <template slot-scope="{data}">
    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
<vs-td :data="data[indextr].name">
        {{ data[indextr].name }}
      </vs-td>
  
      <vs-td :data="data[indextr].kinship">
        {{ data[indextr].kinship }}
      </vs-td>
      
 <vs-td :data="data[indextr].cell">
        {{ data[indextr].cell }}
      </vs-td>

       

      
      <vs-td class="whitespace-no-wrap" :data="data[indextr].id">
       <vs-td class="whitespace-no-wrap" :data="data[indextr].id">
       <vs-row>
                    <vs-button class="mr-3" color="success"  type="border" icon-pack="feather" icon="icon-edit" @click="openUpdateHouseHolds(tr)"></vs-button>

                    <vs-button color="danger"  type="border" icon-pack="feather" icon="icon-trash" @click="deleteHouseHold(tr)"></vs-button>
             </vs-row>
              <!-- <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" /> -->
            </vs-td>
              <!-- <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" /> -->
            </vs-td>

      <!-- <vs-td :data="data[indextr].id">
        {{ data[indextr].id }}
      </vs-td> -->
    </vs-tr>
  </template>
</vs-table>

    <vs-popup class="holamundo" title="Adicionar Parente" :active.sync="popupHouseholds">
    
<form>
       <div class="vx-row">
          <div class="vx-col sm:w-4/4 w-full mb-2">
            <div class="vx-col w-full">
              <label for="">Nome completo</label>
              <vs-input
                class="w-full"
               
                icon-no-border
                v-model="household.name"
                v-validate="'required|alpha_spaces'"
                name="nome"
              />
                 <span class="text-danger text-sm" v-show="errors.has('nome')">{{ errors.first('nome') }}</span>

            </div>
          </div>
           <div class="vx-col sm:w-4/4 w-full mb-2">
            <div class="vx-col w-full">
              <label for="">Grau de parentesto</label>
              <v-select :options="['Trisavô(ó)', 'Bisavô(ó)', 'Avô(ó)', 'Pai', 'Mãe','Esposa(o)','irmão(ã)', 'Filho(a)','Neto(a)','Bisneto(a)', 'Trisneto(a)', 'Sobrinho(a)',]"
               v-model="household.kinship" name="Grau de parentesco" v-validate="'required'">

              </v-select>
             
              <span class="text-danger text-sm" v-show="errors.has('Grau de parentesco')">{{ errors.first('Grau de parentesco') }}</span>
            </div>
          </div>
          

          <div class="vx-col sm:w-4/4 w-full mb-2">
            <div class="vx-col w-full">
              <label for="">Telefone</label>
              <vs-input
                class="w-full"
              
                icon-no-border
                v-model="household.cell"
                 v-validate="'min:12|max:13'"
                 name="Telefone"
              />
               <span class="text-danger text-sm" v-show="errors.has('Numero do documento')">{{ errors.first('Numero do documento') }}</span>
            </div>
          </div>
       
           
          
         
        </div>
        
      
<div class="flex flex-wrap items-center flex-start">
      <vs-button class="ml-auto mt-2" @click.prevent="saveHousehold">Salvar</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>

      
    </div>
    </form>
    </vs-popup>
    
    <!-- EDITAR PARENTE-->
     <vs-popup class="holamundo" title="Actualizar Parente" :active.sync="popupUpdateHouseHolds">
    
<form>
       <div class="vx-row">
          <div class="vx-col sm:w-4/4 w-full mb-2">
            <div class="vx-col w-full">
              <label for="">Nome</label>
              <vs-input
                class="w-full"
                icon-pack="feather"
                icon="icon-check"
                icon-no-border
                v-model="household.name"
                v-validate="'required|alpha_spaces'"
                name="nome"
              />
                 <span class="text-danger text-sm" v-show="errors.has('nome')">{{ errors.first('nome') }}</span>

            </div>
          </div>
           <div class="vx-col sm:w-4/4 w-full mb-2">
            <div class="vx-col w-full">
              <label for="">Grau de parentesto</label>
              <v-select :options="['Trisavô(ó)', 'Bisavô(ó)', 'Avô(ó)', 'Pai', 'Mãe','Esposa(o)','irmão(ã)', 'Filho(a)','Neto(a)','Bisneto(a)', 'Trisneto(a)', 'Sobrinho(a)',]"
               v-model="household.kinship" name="Grau de parentesco" v-validate="'required'">

              </v-select>
             
              <span class="text-danger text-sm" v-show="errors.has('Grau de parentesco')">{{ errors.first('Grau de parentesco') }}</span>
            </div>
          </div>
           
          

          
          <div class="vx-col sm:w-4/4 w-full mb-2">
            <div class="vx-col w-full">
              <label for="">Telefone</label>
              <vs-input
                class="w-full"
                icon-pack="feather"
                icon="icon-check"
                icon-no-border
                v-model="household.cell"
                v-validate="'required|length:9|numeric'"
                name="nuit"
              />
               <span class="text-danger text-sm" v-show="errors.has('telefone')">{{ errors.first('telefone') }}</span>
            </div>
          </div>
           
          
         
        </div>
        
      
<div class="flex flex-wrap items-center flex-start">
      <vs-button class="ml-auto mt-2" @click.prevent="updateHouseHold">Actualizar</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>

      
    </div>
    </form>
    </vs-popup>
    <!-- FIM EDITAR PARENTE-->
    
  </vx-card>
            </vs-collapse-item>


            
        </vs-collapse>
</vx-card>
<div class="flex flex-wrap items-center flex-start">
  <vs-button class="ml-auto mt-2" type="border" iconPack="feather"
icon="icon-refresh-cw" color="success" @click="openDeleteConfirm" >Restaurar Funcionário</vs-button>
</div>


<!--    
   <Documents>
     
   </Documents> -->
  </div>
  
</template>

<script>

// import Documents from "./Documents.vue"
import http from "../../../../../http-common"
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
import { PermissionsMixin } from "../../../../mixins/permissions"

export default {
  mixins:[PermissionsMixin],
  components: {
flatPickr,
    vSelect
  },
  data() {
    return {
      component:[
        {
         id: '',
        amount: '',
        selectedComponent:'',
        }
      ],
      popupAddImposto:false,
      popupAddSubsidio:false,
      document:[
        
      ],
      novoContacto:"",
      contacto:[],
      departments:[],
      documents:[
        {
          name:"",
          type:"",
          attachment:"",
          expiry_date:"",
          number:"",
          issue_date:"",
          
        }
      ],
      households:[],
      educations:[],
      work_experiences:[],
      work_experience:[
        {
        company_name:"",
        address:"",
        position:"",
        end_date:"",
        start_date:"",


        }
      ],
      employee:[{
        user:[{
          name:"",
        }],
  contacts:[
    {
    phone:"",
    id:"",
  },
  
   ]
}],

renewContract:[
  {
    type:"",
    expiry_date:"",
    start_date:"",
    renewals_number:0,
  }
],

contracts:[
  {
    type:"",
    renewals_number:0,
    expiry_date:"",
    employee_id:"",
    status:"",
  }
],
contract:{
id:"",
expiry_date:"",
type:"",  
renewals_number:0,
},
      dependents:[],
      name:"",
      surname:"",
      activeTab: 0,
dependet_birth_date:"",
dependent_name:"",
dependent_docNumber:"",
selectedPosition:"",
company_roles:[],

deficiencies:[],
contrato:[],
deficiency:[{
  description:"",
  type:""
}],
household:[{
  doc_type:"",
  name:"",
  kinship:"",
  doc_number:"",
  nuit:"",
  cell:"",
  
}],
dependent:[
  {
    birth_date:"",
    name:"",
    knship:"",
  },
 
],
dependent_doc_type:"",
dependenteGrau:"",
education:[
  {

  }
],

input1:"",
department_name:"",
document_type: "BI",

company_name:"",
position:"",
address:"",
start_date:"",
end_date:"",


/////////EDITAR/////
popupUpdateHouseHolds:false,
popupUpdateDeficiency:false,
popupUpdateAfiliados:false,
popupUpdateEducations:false,
popupUpdateWorkExperience:false,
popupUpdateDocument:false,

ficheiro:"",
/////////Gravar/////
popupAfiliados:false,
popupActive: false,
popupVerRenovacao:false,
popupEducations:false,
popupDocument:false,
popupProcess:false,
popupWorkExperience:false,
popupHouseholds:false,
popupDeficiency:false,
popupContratos:false,
popupRenovar:false,
popupEstado:false,
popupDetalhes:false,
popupContactos:false,
popupEditContactos:false,


ficheiro1:"",
ficheiro2:"",
ficheiro3:"",
ficheiro4:"",
ficheiro5:"",
ficheiro6:"",
ficheiro7:"",
ficheiro8:"",

course:"",
school_name:"",
conclusion_year:"",
level:"",
file:"",
selectedDepartment:"",
process:false,

type:"",
          expiry_date:"",
          attachment:"",
          employee_id:"",
          number:"",

imagem:"",

       
        responsabilities:[],
         inputs: [{
        component_id: [],
        amount: '',
      }],
      //   inputss: [{
      //   name: '',
      //   party: ''
      // }],
      responsability_names: [{
        responsability_name: '',
        
      }],
        responsible_id:"",
employees:[
 
],
subsidios:[],
impostos:[],
arrayObjSubsidio:[],
arrayObjImposto:[],
spouse:"",
student:"",
employee_structure:"",
components:[],
structure_components:[],
popupEditSubsidio:false,
dado:{
  pivot:{
    amount:"",
    id:""
}
},

 err:"",
   options: ["Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antarctica", "Antigua and Barbuda",
"Argentina", "Armenia", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados",
"Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana",
"Brazil", "Brunei", "Bulgaria", "Burkina Faso", "Burma", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde",
"Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo, Democratic Republic",
"Congo, Republic of the", "Costa Rica", "Cote d'Ivoire", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark",
"Djibouti", "Dominica", "Dominican Republic", "East Timor", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea",
"Eritrea", "Estonia", "Ethiopia", "Fiji", "Finland", "France", "Gabon", "Gambia", "Georgia", "Germany", "Ghana",
"Greece", "Greenland", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras", "Hong Kong",
"Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy", "Jamaica", "Japan",
"Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea, North", "Korea, South", "Kuwait", "Kyrgyzstan", "Laos", "Latvia",
"Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macedonia", "Madagascar",
"Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia",
"Moldova", "Mongolia", "Morocco", "Monaco", "Mozambique", "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand",
"Nicaragua", "Niger", "Nigeria", "Norway", "Oman", "Pakistan", "Panama", "Papua New Guinea", "Paraguay", "Peru",
"Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russia", "Rwanda", "Samoa", "San Marino", " Sao Tome",
"Saudi Arabia", "Senegal", "Serbia and Montenegro", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia",
"Solomon Islands", "Somalia", "South Africa", "Spain", "Sri Lanka", "Sudan", "Suriname", "Swaziland", "Sweden",
"Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Togo", "Tonga", "Trinidad and Tobago",
"Tunisia", "Turkey", "Turkmenistan", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States",
"Uruguay", "Uzbekistan", "Vanuatu", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"
      ],
    }
  },

 

async mounted(){
  await this.getData(),
this.initialize()

},

  methods: {
initialize(){
  
  
  this.getDepartments(),
  this.getCompanyRoles(),
  
  // this.getEmployees(),
  this.getComponent(),
  this.getStructures()
  
},

popupOpenEditContacto(data){
         this.contacto = data;
         this.popupEditContactos=true

          
        },
       
        async delete() {
         
            this.$vs.loading()
 
 
       let token = localStorage.getItem("token");
       let config = {
         headers: {
           authorization: "Bearer " + token,
         },
       };
   
       
 
      http
         .put(`/employees/disable/${this.employee.id}`,{},config)
         .then((success) => {
           success;
           this.$vs.loading.close();
           this.$vs.notify({
             title: "Sucesso",
             text: "Removido com sucesso!",
             color: "success",
             position: "top-right",
           })
           this.$router.push('/pages/employee/user-list');
         })
         .catch((error) => {
           error;
           this.err= error.response.data
           this.$vs.loading.close();
           this.$vs.notify({
             title: "Erro",
             text: this.err,
             iconPack: "feather",
             icon: "icon-alert-circle",
             color: "danger",
             position: "top-right",
           })
         });
         // }})
 
    
     },
async updateEditContacto() {
        //      this.$validator.validateAll().then(result => {
        // if (result) {
           this.$vs.loading()


      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      const data = {
          amount:this.dado.pivot.amount,        
      };

      this.$validator.validateAll();
     http
        .patch(`/salaries/update-components/${this.dado.pivot.id}`, data, config)
        .then((success) => {
          success;
        this.popupEditSubsidio=false,
        
        this.getData(),
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Actualizado com sucesso!",
            color: "success",
            position: "top-right",
          })
        })
        .catch((error) => {
          error;
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
        // }})

   
    },


    openDeleteConfirm() {
  this.$vs.dialog({
      type: 'confirm',
      color: 'danger',
      title: `Confirmação`,
      text: 'Tem certeza que deseja Restaurar?' ,
      accept: this.delete
  })
},
async delete() {

this.$vs.loading()


let token = localStorage.getItem("token");
let config = {
headers: {
authorization: "Bearer " + token,
},
};



http
.put(`/employees/disable/${this.employee.id}`,{},config)
.then((success) => {
success;
this.$vs.loading.close();
this.$vs.notify({
 title: "Sucesso",
 text: "Restarado com sucesso!",
 color: "success",
 position: "top-right",
})
this.$router.push('/pages/employee/user-list');
})
.catch((error) => {
error;
this.err= error.response.data
this.$vs.loading.close();
this.$vs.notify({
 title: "Erro",
 text: this.err,
 iconPack: "feather",
 icon: "icon-alert-circle",
 color: "danger",
 position: "top-right",
})
});
// }})


},
  
openComponentConfirm(componente) {
this.componente=componente,
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Confirmação`,
                text: 'Tem certeza que deseja eliminar?' ,
                accept: this.cancel
            })
        },

               async cancel() {
        
          //  this.$vs.loading()


      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
  
      

      this.$validator.validateAll();
     http
        .delete(`/salaries/remove-component-structures/${this.componente.pivot.id}`,config)
        .then((success) => {
          success;
        this.popupEdit=false,
        
        this.getData(),
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Removido com sucesso!",
            color: "success",
            position: "top-right",
          })
        })
        .catch((error) => {
          error;
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
        // }})

   
    },



          async cancel() {
         
           this.$vs.loading()


      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
  
      

      this.$validator.validateAll();
     http
        .delete(`/salaries/remove-component-structures/${this.componente.pivot.id}`,config)
        .then((success) => {
          success;
        this.popupEdit=false,
        
        this.getData(),
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Removido com sucesso!",
            color: "success",
            position: "top-right",
          })
        })
        .catch((error) => {
          error;
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
        // }})

   
    },



popupOpenEditSubsidio(component){
   this.dado=component,
         this.popupEditSubsidio=true

          
        },

           async updateComponent() {
        //      this.$validator.validateAll().then(result => {
        // if (result) {
           this.$vs.loading()


      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      const data = {
          amount:this.dado.pivot.amount,        
      };

      this.$validator.validateAll();
     http
        .patch(`/salaries/update-components/${this.dado.pivot.id}`, data, config)
        .then((success) => {
          success;
        this.popupEditSubsidio=false,
        
        this.getData(),
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Actualizado com sucesso!",
            color: "success",
            position: "top-right",
          })
        })
        .catch((error) => {
          error;
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
        // }})

   
    },




 getStructures() {
     
      //    this.$vs.loading({
      //   container: '#div-with-loading',
      //   scale: 1.0,
      //   type:'sound'
      // })
     
    
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      http
        .get("/salaries/salary-structures/"+this.employee_structure, config)
        .then((result) => {
         
              // this.$vs.loading.close('#div-with-loading > .con-vs-loading')
              
          this.structure_components = result.data.salary_components
          this.structures = result.data
          
        
          
          // this.user = result.data.structure_employee.user
// alert("2")
        })
        .catch((error) => {
          error;
          
          if(error.response.status==401 ){
            this.$router.push('/').catch(() => {})
          }
         
        });
    },

  getComponent() {
      
    
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      
      http
        .get("/salaries/components", config)
        .then((result) => {
          this.components = result.data.SalaryComponents


          ////////////////  FILTRAR SUBSIDIOS ////////////////////////////
          this.subsidios = this.components.filter((subsidio) => {
           
    if(subsidio.abbreviation != "INSS" && subsidio.abbreviation != "IRPS") {
      
      return subsidio
  }
})

////////////////  FILTRAR IMPOSTOS ////////////////////////////
this.impostos = this.components.filter((imposto) => {
 
    if(imposto.abbreviation == "INSS" || imposto.abbreviation == "IRPS") {
      
      return imposto
  }
})


        this.arrayObjSubsidio = this.subsidios.map(item => {
        
      return {
        id: item.id,
        label: item.name
      };
    });

    this.arrayObjImposto = this.impostos.map(item => {
      return {
        id: item.id,
        label: item.name
      };
    });
          this.novo=this.components.map(d =>  d.responsability_name)
// alert("2")
        })
        .catch((error) => {
          error;
          
          if(error.response.status==401 ){
            this.$router.push('/').catch(() => {})
          }
         
        });
    },
        async saveComponent() {
            
        //      this.$validator.validateAll().then(result => {
        // if (result) {
          
           this.$vs.loading()


      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
  
      const data = {
          components:JSON.stringify(this.inputs)
          
      };

     http
        .post("/salaries/add-components/"+this.employee_structure, data, config)
        .then((success) => {
          success;
        this.popupAddImposto=false,
        this.popupAddSubsidio=false,
        // this.inputs=[],
        this.getStructures(),
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Adicionado com sucesso!",
            color: "success",
            position: "top-right",
          })
        })
        .catch((error) => {
          error;
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
        // }})

   
    },
    openConfirm(componente) {
this.componente=componente,
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Confirmação`,
                text: 'Tem certeza que deseja eliminar?' ,
                accept: this.cancel
            })
        },


          async cancel() {
         
           this.$vs.loading()


      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
  
      

      this.$validator.validateAll();
     http
        .delete(`/salaries/remove-component-structures/${this.componente.pivot.id}`,config)
        .then((success) => {
          success;
        this.popupEdit=false,
        
        this.getComponent(),
        this.getStructures(),
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Removido com sucesso!",
            color: "success",
            position: "top-right",
          })
        })
        .catch((error) => {
          error;
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
        // }})

   
    },


  add () {
      this.inputs.push({
        component_id: '',
        amount: ''
      })
    },

    remove (index) {
      this.inputs.splice(index, 1)
    },

    addCandidate () {
      
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
  
      const data = {
          name:'Teste',
          component:JSON.stringify(this.inputs)
          
      };

     http
        .post("/salaries/salary-structures", data, config)
        .then((success) => {
          success;
        this.popupAdd=false,
        
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Estrutura salaria adicionado com sucesso!",
            color: "success",
            position: "top-right",
          })
        })
        .catch((error) => {
          error;
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });

    },

previewImage(event) {
            this.attachment = event.target.files[0]
            this.imagem = event.target.files[0]
        },

    openUpdateDocument(document){
         this.document = document;
         this.popupUpdateDocument=true

          
        },

             async updateDocument() {
     this.$vs.loading()
   
      let token = localStorage.getItem("token");
      let config = {
        headers: {
                         authorization: "Bearer " + token,
                        'content-type': "multipart/form-data"
                    },
      };
      const data = new FormData();
  data.append('attachment', this.attachment);
  data.append('name', this.document.name);
  data.append("employee_id", this.$route.params.employeeId) 
  data.append("expiry_date", this.document.expiry_date) 
    data.append("type", this.document.type) 
      data.append("number", this.document.number) 
data.append("document_id", this.document.id) 
      this.$validator.validateAll();
      await http
        .post("/update_document", data, config)
        .then((success) => {
          success;
        this.popupUpdateDocument=false,
        
        this.getData(),
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Documento actualizado com sucesso",
            color: "success",
            position: "top-right",
          })
        })
        .catch((error) => {
          error;
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
    },

        openUpdateEducations(data){
         this.education = data;
         this.popupUpdateEducations=true

          
        },


openWorkExperience(data){
         this.work_experience = data;
         this.popupUpdateWorkExperience=true

          
        },
                  async deleteWorkExperience(data) {
        this.work_experience = data;
    this.$vs.loading()

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
  
      

      this.$validator.validateAll();
      await http
        .delete(`/employees/work_experiences/${this.work_experience.id}`, config)
        .then((success) => {
          success;
        
       this.getData(),
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Formacao eliminado com sucesso",
            color: "success",
            position: "top-right",
          })
        })
 
        .catch((error) => {
          error;
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
    },


          async updateWorkExperience() {
    this.$vs.loading()
     
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
  
      const data = {
           company_name:this.work_experience.company_name,
          position:this.work_experience.position,
          address:this.work_experience.address,
          start_date:this.work_experience.start_date,
          end_date:this.work_experience.end_date,

          

          
      };

      this.$validator.validateAll();
      await http
        .put(`/employees/work_experiences/${this.work_experience.id}`, data, config)
        .then((success) => {
          success;
        this.popupUpdateEducations=false,
        
        this.getData(),
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Experiencia actualizada com sucesso",
            color: "success",
            position: "top-right",
          })
        })
        .catch((error) => {
          error;
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
    },

          async updateEducations() {
    this.$vs.loading()
  
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
  
      const data = {
           school_name:this.education.school_name,
          conclusion_year:this.education.conclusion_year,
          level:this.education.level,
          course:this.education.course,

          
      };

      this.$validator.validateAll();
      await http
        .put(`/employees/educations/${this.education.id}`, data, config)
        .then((success) => {
          success;
        this.popupUpdateEducations=false,
        
        this.getData(),
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Formacao actualizada com sucesso",
            color: "success",
            position: "top-right",
          })
        })
        .catch((error) => {
          error;
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
    },
          async deleteEducations(data) {
        this.education = data;
    this.$vs.loading()

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
  
      

      this.$validator.validateAll();
      await http
        .delete(`/employees/educations/${this.education.id}`, config)
        .then((success) => {
          success;
        
       this.getData(),
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Formacao eliminado com sucesso",
            color: "success",
            position: "top-right",
          })
        })
 
        .catch((error) => {
          error;
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
    },


 openUpdateAfiliados(data){
         this.dependent = data;
         this.popupUpdateAfiliados=true

          
        },

   updateAfiliados() {
    this.$vs.loading()

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
  
      const data = {
          birth_date:this.dependent.birth_date,
          name: this.dependent.name,
          doc_type: this.dependent.doc_type,
          kinship:this.dependent.kinship,
          doc_number:this.doc_number,
          
      };

     

      this.$validator.validateAll();
       http
        .put(`/employees/dependents/${this.dependent.id}`, data, config)
        .then((success) => {
          success;
        this.popupUpdateAfiliados=false,
        
        this.getData(),
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Actualizado com sucesso",
            color: "success",
            position: "top-right",
          })
        })
        .catch((error) => {
          error;
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
    },
      async deleteAfiliados(data) {
        this.dependent = data;
    this.$vs.loading()

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
  
      

      this.$validator.validateAll();
      await http
        .delete(`/employees/dependents/${this.dependent.id}`, config)
        .then((success) => {
          success;
        
       this.getData(),
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Dependente eliminado com sucesso",
            color: "success",
            position: "top-right",
          })
        })
 
        .catch((error) => {
          error;
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
    },

 openUpdateDeficiency(data){
         this.deficiency = data;
         this.popupUpdateDeficiency=true

          
        },

             async updateDeficiency() {
    this.$vs.loading()

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
  
      const data = {
         description: this.deficiency.description,
         type: this.deficiency.type,
          
      };

      this.$validator.validateAll();
      await http
        .put(`/employees/deficiencies/${this.deficiency.id}`, data, config)
        .then((success) => {
          success;
        this.popupUpdateDeficiency=false,
        
        this.getData(),
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Deficiencia actualizada com sucesso",
            color: "success",
            position: "top-right",
          })
        })
        .catch((error) => {
          error;
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
    },


        async deleteDeficiency(data) {
        this.deficiency = data;
    this.$vs.loading()
   
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
  
      

      this.$validator.validateAll();
      await http
        .delete(`/employees/deficiencies/${this.deficiency.id}`, config)
        .then((success) => {
          success;
        
       this.getData(),
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Parente eliminado com sucesso",
            color: "success",
            position: "top-right",
          })
        })
 
        .catch((error) => {
          error;
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
    },

 openUpdateHouseHolds(data){
         this.household = data;
         this.popupUpdateHouseHolds=true

          
        },

        
        async updateHouseHold() {
    this.$vs.loading()

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
  
      const data = {
         name:this.household.name,
          doc_type:this.household.doc_type,
          doc_number:this.household.doc_number,
          nuit:this.household.nuit,
          kinship:this.household.kinship,
          cell:this.household.cell,
          employee_id:this.$route.params.employeeId,
          
      };

      this.$validator.validateAll();
      await http
        .put(`/employees/households/${this.household.id}`, data, config)
        .then((success) => {
          success;
        this.popupUpdateHouseHolds=false,
        
        this.getData(),
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Parente salvo com sucesso",
            color: "success",
            position: "top-right",
          })
        })
        .catch((error) => {
          error;
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
    },

       async deleteHouseHold(data) {
        this.household = data;
    this.$vs.loading()
    
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
  
      

      this.$validator.validateAll();
      await http
        .delete(`/employees/households/${this.household.id}`, config)
        .then((success) => {
          success;
        
       this.getData(),
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Parente salvo com sucesso",
            color: "success",
            position: "top-right",
          })
        })
 
        .catch((error) => {
          error;
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
    },
      
  


  async saveDocument() {
     this.$vs.loading()

      let token = localStorage.getItem("token");
      let config = {
        headers: {
                         authorization: "Bearer " + token,
                        'content-type': "multipart/form-data"
                    },
      };
      const data = new FormData();
  data.append('attachment', this.attachment);
  data.append('name', this.documents.name);
  data.append("employee_id", this.$route.params.employeeId) 
  data.append("expiry_date", this.documents.expiry_date) 
    data.append("type", this.documents.type) 
      data.append("number", this.documents.number) 
      data.append("issue_date", this.documents.issue_date) 
      


      this.$validator.validateAll();
      await http
        .post("/documents", data, config)
        .then((success) => {
          success;
           this.attachment="",
   this.documents.name="",
  this.documents.expiry_date="", 
  this.documents.type="",
      this.documents.number=""
            
     
        this.popupDocument=false,
        
        this.getData(),
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Documento salvo com sucesso",
            color: "success",
            position: "top-right",
          })
        })
        .catch((error) => {
          error;
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
    },
///////////////////////////////////PROCESSOS//////////////////////////////////////
    async saveProcesso() {
     this.$vs.loading()

      let token = localStorage.getItem("token");
      let config = {
        headers: {
                         authorization: "Bearer " + token,
                        'content-type': "multipart/form-data"
                    },
      };
      const data = new FormData();
  data.append('attachment', this.attachment);
  data.append('name', this.documents.name);
  data.append("employee_id", this.$route.params.employeeId) 
  data.append("expiry_date", this.documents.expiry_date) 
    data.append("type", this.documents.type) 
      data.append("number", this.documents.number) 


      this.$validator.validateAll();
      await http
        .post("/employees/processes", data, config)
        .then((success) => {
          success;
           this.attachment="",
   this.documents.name="",
  this.documents.expiry_date="", 
  this.documents.type="",
      this.documents.number=""
            
     
        this.popupProcess=false,
        
        this.getData(),
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Gravado com sucesso",
            color: "success",
            position: "top-right",
          })
        })
        .catch((error) => {
          error;
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
    },
  popupRenovarContrato(data){
         this.contract = data;
         this.popupRenovar=true

          
        },
       

        popupCessar(data){
         this.contract = data;
         this.popupEstado=true

          
        },

         popupVerRenovacoes(data){
         this.contract = data;
         this.popupVerRenovacao=true

          
        },

        popupVerDetalhes(data){
         this.contract = data;
         this.popupDetalhes=true

          
        },

        async saveCessar() {
    this.$vs.loading()

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
  
      const data = {
          status:this.contract.status,

          
      };

      this.$validator.validateAll();
      await http
        .patch(`employees/contracts/ceases/${this.contract.id}`, data, config)
        .then((success) => {
          success;
        this.popupEstado=false,
        this.contract.status="",
        
        this.getData(),
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Contrato Cessado com sucesso",
            color: "success",
            position: "top-right",
          })
        })
        .catch((error) => {
          error;
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
    },

async saveRenovar() {
    this.$vs.loading()

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
  
      const data = {
          expiry_date: this.renewContract.expiry_date,
          start_date: this.renewContract.start_date,

          
      };

      this.$validator.validateAll();
      await http
        .put(`employees/contracts/renews/${this.contract.id}`, data, config)
        .then((success) => {
          success;
         this.renewContract.expiry_date="",
          this.renewContract.start_date="",
        this.popupRenovar=false,
        
        this.getData(),
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Contrato salvo com sucesso",
            color: "success",
            position: "top-right",
          })
        })
        .catch((error) => {
          error;
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
    },

async saveContracts() {
    this.$vs.loading()

      let token = localStorage.getItem("token");
      let config = {
        headers: {
                         authorization: "Bearer " + token,
                        'content-type': "multipart/form-data"
                    },
      };
  
      // const data = {
      //     type:this.contracts.type,
      //     renewals_number:this.contracts.renewals_number,
      //     expiry_date:this.contracts.expiry_date,
      //     start_date:this.contracts.start_date,
      //     status:this.contracts.status,
      //     employee_id:this.$route.params.employeeId,

          
      // };


      
      const data = new FormData();
  data.append('attachment', this.attachment);
  data.append('type', this.contracts.type);
  data.append("renewals_number", this.contracts.renewals_number) 
  data.append("expiry_date", this.contracts.expiry_date) 
  data.append("start_date", this.contracts.start_date) 
  // data.append("status", this.contracts.status) 
  data.append("employee_id", this.$route.params.employeeId) 
  
      this.$validator.validateAll();
      await http
        .post("/employees/contracts", data, config)
        .then((success) => {
          success;
            this.popupContratos=false,
           this.contracts.type=""
          this.contracts.renewals_number="",
         this.contracts.expiry_date="",
          this.contracts.start_date="",
          this.contracts.status="",
      
        this.getData(),
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Contrato salvo com sucesso",
            color: "success",
            position: "top-right",
          })
        })
        .catch((error) => {
          error;
           this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
    },
  async saveDependents() {
      this.$vs.loading()
     
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
  
      const data = {
          birth_date:this.dependet_birth_date,
          name: this.dependent_name,
          employee_id:this.$route.params.employeeId,
          kinship: this.dependenteGrau,
          doc_number:this.dependent_docNumber,
          doc_type:this.dependent_doc_type

          
          
      };

      this.$validator.validateAll();
      await http
        .post("/employees/dependents", data, config)
        .then((success) => {
          success;
        this.popupAfiliados=false,
        this.dependet_birth_date="",
          this.dependent_name="",
        this.getData(),
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Dependente salvo com sucesso",
            color: "success",
            position: "top-right",
          })
        })
        .catch((error) => {
          error;
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text:this.err ,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
    },



  async saveProfilePicture() {
    this.process=true;
      let token = localStorage.getItem("token");
      let config = {
        headers: {
                         authorization: "Bearer " + token,
                        'content-type': "multipart/form-data"
                    },
      };
      const data = new FormData();
  data.append('image', this.imagem);
  data.append("user_id", this.employee.user_id) 



      this.$validator.validateAll();
      await http
        .post("/users/upload_profile", data, config)
        .then((success) => {
          this.getData(),
          this.process=false;
          this.imagem="",
          success;
        
          this.$vs.notify({
            title: "Sucesso",
            text: "Foto de perfil actualizada com sucesso",
            color: "success",
            position: "top-right",
          })
        })
        .catch((error) => {
          error;
          this.process=false;
          this.$vs.notify({
            title: "Erro",
            text: "falha ao Foto de perfil ",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
    },
 

    async saveWorkExperience() {
        this.$vs.loading()
  
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
  
      const data = {
          company_name:this.company_name,
          position:this.position,
          address:this.address,
          start_date:this.start_date,
          end_date:this.end_date,
          employee_id:this.$route.params.employeeId,

          
      };

      this.$validator.validateAll();
      await http
        .post("/employees/work_experiences", data, config)
        .then((success) => {
          success;
        this.popupWorkExperience=false,
      this.company_name="",
         this.position="",
          this.address="",
          this.start_date="",
          this.end_date="",

        this.getData(),
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Historico salvo com sucesso",
            color: "success",
            position: "top-right",
          })
        })
       .catch((error) => {
          error;
          if(error.response.status==401 ){
            this.$router.push('/').catch(() => {})
          }
          if(error.response.status==422 ){
          this.err= error.response.data
          console.log(this.err)
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
          }else{
          this.$vs.notify({
            title: "Erro",
            text: "Aconteceu algum erro",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
          }
          
        });
    },

    // deleteContact(){
    //   this.$vs.loading()
    
    // let token = localStorage.getItem("token");
    // let config = {
    //   headers: {
    //     authorization: "Bearer " + token,
    //   },
    // };
    // await http
    //     .delete("/users/contacts", data, config)
    //     .then((success) => {
    //       success
    //       this.getData(),
    // })
    //    .catch((error) => {
    //       error;
    //     })
    // },
    
      
    async deleteContact(data) {
        this.contacto = data;
    this.$vs.loading()

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
  
      

      this.$validator.validateAll();
      await http
        .delete(`/users/contacts/${this.contacto.id}`, config)
        .then((success) => {
          success;
        
       this.getData(),
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "eliminado com sucesso",
            color: "success",
            position: "top-right",
          })
        })
 
        .catch((error) => {
          error;
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
    },


    async updateContact() {
        this.$vs.loading()
    
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
  
      const data = {
          phone:this.contacto.phone,
          employee_id:this.$route.params.employeeId,

          
      };

      this.$validator.validateAll();
      await http
        .update("/users/contacts", data, config)
        .then((success) => {
          success;
        this.popupEditContactos=false,
 
        this.getData(),
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Actualizado com sucesso",
            color: "success",
            position: "top-right",
          })
        })
       .catch((error) => {
          error;
          if(error.response.status==401 ){
            this.$router.push('/').catch(() => {})
          }
          if(error.response.status==422 ){
          this.err= error.response.data
          console.log(this.err)
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
          }else{
          this.$vs.notify({
            title: "Erro",
            text: "Aconteceu algum erro",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
          }
          
        });
    },
 async saveContact() {
        this.$vs.loading()
    
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
  
      const data = {
          phone:this.novoContacto,
          employee_id:this.$route.params.employeeId,

          
      };

      this.$validator.validateAll();
      await http
        .post("/users/contacts", data, config)
        .then((success) => {
          success;
        this.popupContactos=false,
        this.novoContacto="",
        this.getData(),
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Contacto salvo com sucesso",
            color: "success",
            position: "top-right",
          })
        })
       .catch((error) => {
          error;
          if(error.response.status==401 ){
            this.$router.push('/').catch(() => {})
          }
          if(error.response.status==422 ){
          this.err= error.response.data
          console.log(this.err)
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
          }else{
          this.$vs.notify({
            title: "Erro",
            text: "Aconteceu algum erro",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
          }
          
        });
    },
     async saveContact() {
        this.$vs.loading()
    
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
  
      const data = {
          phone:this.novoContacto,
          employee_id:this.$route.params.employeeId,

          
      };

      this.$validator.validateAll();
      await http
        .post("/users/contacts", data, config)
        .then((success) => {
          success;
        this.popupContactos=false,
        this.novoContacto="",
        this.getData(),
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Contacto salvo com sucesso",
            color: "success",
            position: "top-right",
          })
        })
       .catch((error) => {
          error;
          if(error.response.status==401 ){
            this.$router.push('/').catch(() => {})
          }
          if(error.response.status==422 ){
          this.err= error.response.data
          console.log(this.err)
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
          }else{
          this.$vs.notify({
            title: "Erro",
            text: "Aconteceu algum erro",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
          }
          
        });
    },
getCompanyRoles() {
   this.$vs.loading()
 
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      
      http
        .get("/companies/companies_role", config)
        .then((result) => {
          this.company_roles = result.data.Company_roles.reverse()
           this.$vs.loading.close()
          
        })
        .catch((error) => {
          error;
           this.$vs.loading.close()
         if(error.response.status==401 ){
            this.$router.push('/').catch(() => {})
          }
        });
    },


     async saveEducation() {
         this.$vs.loading()

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
  
      const data = {
          school_name:this.school_name,
          conclusion_year:this.conclusion_year,
          level:this.level,
          employee_id:this.$route.params.employeeId,
          course:this.course,

          
      };

      this.$validator.validateAll();
      await http
        .post("/employees/educations", data, config)
        .then((success) => {
          success;
          
          this.getData()
        this.popupEducations=false,
      this.school_name="",
          this.conclusion_year=""
         this.level=""
         this.course=""

          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Formacao Academica salva com sucesso",
            color: "success",
            position: "top-right",
          })
        })
        .catch((error) => {
          error;
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
    },


 saveHousehold() {

            // this.$validator.validateAll().then(result => {
                // if(result) {
                    this.$vs.loading()
           let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token
        },
      };
  
      const data = {
          name:this.household.name,
          doc_type:this.household.doc_type,
          doc_number:this.household.doc_number,
          nuit:this.household.nuit,
          kinship:this.household.kinship,
          cell:this.household.cell,
          employee_id:this.$route.params.employeeId,

          
      };

       http
        .post("/employees/households", data, config)
        .then((success) => {
          success;
          this.getData()
        this.popupHouseholds=false,
        this.household.name="",
          this.household.doc_type="",
          this.household.doc_number="",
         this.household.nuit="",
         this.household.kinship="",
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Parente salvo com sucesso",
            color: "success",
            position: "top-right",
          })
        })
        .catch((error) => {
          error;
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: "falha ao salvar Parente",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
                // }else{
                //     // form have errors
                // }
            // })
        },

      getEmployees() {
         this.$vs.loading()
    
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
        params:{
          status:1
        }
      };
      
      http
        .get("/employees/employees", config)
        .then((result) => {
          this.employees = result.data.Employees.reverse();
    this.$vs.loading.close()
        })
        .catch((error) => {
          this.$vs.loading.close()
          error;
         
        });
    },

    getDepartments() {
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      
      http
        .get("/companies/departments", config)
        .then((result) => {
          this.departments = result.data.Departments.reverse();
        })
        .catch((error) => {
          error;
         
        });
    },

    

       async saveDeficiency() {
           this.$vs.loading()
     
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
  
      const data = {
          description: this.deficiency.description,
          type: this.deficiency.type,
          employee_id:this.$route.params.employeeId,

          
      };

      this.$validator.validateAll();
      await http
        .post("/employees/deficiencies", data, config)
        .then((success) => {
          success;
          this.getData()
        this.popupDeficiency=false,
        this.deficiency.description="",
        this.deficiency.type="",
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Deficiencia Adicionada com sucesso",
            color: "success",
            position: "top-right",
          })
        })
        .catch((error) => {
          error;
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: "falha ao salvar Deficiencia",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
    },
    async  getData() {
         this.$vs.loading()
      
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
     

    await  http
        .get(`/employees/employees/${this.$route.params.employeeId}`, config)
        .then((result) => {
          this.$vs.loading.close()
          this.employee = result.data.Employee;
          this.dependents = result.data.Employee.dependents
          this.work_experiences = result.data.Employee.work_experiences
          this.educations = result.data.Employee.educations
          this.households = result.data.Employee.households
          this.deficiencies= result.data.Employee.deficiencies
          this.documents= result.data.Employee.documents
          this.employee.contacts.phone = result.data.Employee.contacts[0].phone
           this.employee.contacts.id = result.data.Employee.contacts[0].id
          this.selectedDepartment=result.data.Employee.department
          this.selectedPosition=result.data.Employee.position
          this.contracts= result.data.Employee.contracts
          this.contacts = result.data.Employee.contacts
          this.employee_structure= result.data.Employee.employee_structure[0].id

          
        })
        .catch((error) => {
          error
          this.$vs.loading.close();
        });
    },



   async EditEmployee() {
        this.$vs.loading()
     
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
  
      const data = {
        user_id:this.employee.user.id,
        inss:this.employee.inss,
        nuit:this.employee.nuit,
        name: this.employee.user.name,
        surname: this.employee.user.surname,
        email: this.employee.user.email,
        phone: this.employee.contacts.phone,
        contact_id:this.employee.contacts.id,
        birth_date: this.employee.birth_date,
        marital_status: this.employee.marital_status,
        gender: this.employee.gender,
        address: this.employee.address,
        nationality: this.employee.nationality,
        basic_salary: this.employee.basic_salary,
        document_type: this.employee.document_type,
        document_number:this.employee.document_number,
        position_id:this.selectedPosition.id,
        department_id:this.selectedDepartment.id,
       
        
      };

      this.$validator.validateAll();
      await http
        .put(`/employees/employees/${this.$route.params.employeeId}`,data, config)
        .then((success) => {
          success;
        this.popupWorkExperience=false,
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Utilizador actualizado com sucesso",
            color: "success",
            position: "top-right",
          })
        })
       .catch((error) => {
          error;
          if(error.response.status==422 ){
            this.$vs.loading.close();
          this.err= error.response.data
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
          }else{
            this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: "Aconteceu algum erro",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
          }
          
        });
    },
    


  
},
 watch: {
      //   currentUser() {
      //       this.verifyPermissions()
      // }
}
 
}

</script>
